<mat-card
  style="background-color:  #003057; border: none"
  class="mat-elevation-z10"
>
  <mat-card-content>
    <div class="form-bg" *ngIf="!preference">
      <div
        *ngIf="errorMessageIntialData == ''"
        class="d-flex justify-content-center alert alert-warning alert-dismissible fade show"
        role="alert"
      >
        <div *ngIf="errorMessageIntialData == ''">
          Loading...
          <div class="spinner-border text-primary" role="status"></div>
        </div>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="alert"
          aria-label="Close"
        ></button>
      </div>
    </div>
    <div
      *ngIf="errorMessage != ''"
      class="d-flex justify-content-center alert alert-danger alert-dismissible fade show fs-3"
      role="alert"
      (closed)="errorMessage = ''"
    >
      <i class="bi bi-exclamation-triangle-fill px-2"></i>
      {{ errorMessage }}
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
    </div>
    <div
      *ngIf="successMessage != ''"
      class="d-flex justify-content-center alert alert-success alert-dismissible fade show fs-3"
      role="alert"
      (closed)="successMessage = ''"
    >
      <i class="bi bi-check-circle-fill px-2"></i>
      <i class="bi bi-exclamation-triangle-fill px-2"></i>
      {{ successMessage }}
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
    </div>
    <div
      *ngIf="warningMessage != ''"
      class="d-flex justify-content-center alert alert-warning alert-dismissible fade show fs-3"
      role="alert"
      (closed)="warningMessage = ''"
    >
      {{ warningMessage }}
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
    </div>
    <div *ngIf="!isValidFormSubmitted">
      <div class="form-bg" *ngIf="preference">
        <form
          focusFirstInvalidField
          #customerForm="ngForm"
          name="customerForm"
          class="customer-form"
          novalidate
        >
          <div class="container-fluid">
            <div class="row">
              <app-timer-nv [resetTime]="timerReset"
              [isValidFormSubmitted]="isValidFormSubmitted"
              (changeResetMessageCalled)="changeResetMessage()"
            ></app-timer-nv>
            </div>
            <div class="row">
              <div class="col fw-bold" style="color: yellow">
                *These are required fields. Make sure you fill in these boxes.
              </div>
            </div>
            <mat-horizontal-stepper
              linear
              #stepper
              class="rounded"
              style="border: 2px solid #63b1bc"
              aria-busy="true"
            >
              <mat-step
                label="Policyholder Info"
                aria-label="Create Policyholder Info"
                [completed]="policyHolderCheck()"
              >
                <fieldset
                  class="shadow p-5 mb-1 rounded-5"
                  style="border: 2px solid #63b1bc"
                >
                  <legend
                    class="float-none w-auto p-1 mx-5 fw-bold fs-1"
                    style="color: #003057"
                  >
                    Apply Now
                  </legend>

                  <input
                    type="hidden"
                    name="existingMember"
                    [(ngModel)]="existingMember"
                    #existingMembers="ngModel"
                    style="display: none"
                  />
                  <mat-card
                    *ngIf="existingMember == null"
                    class="mat-elevation-z8"
                  >
                    <mat-card-content>
                      <div class="row" style="padding-bottom: 14px;">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >First Name<ng-container
                                *ngIf="!firstNameRequired"
                                >*</ng-container
                              ></mat-label
                            >

                            <input
                              matInput
                              type="text"
                              name="memberVO.firstNm"
                              [(ngModel)]="memberObj1.firstNm"
                              uppercase
                              #memberVOfirstNm="ngModel"
                              pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                              maxlength="20"
                              (keypress)="
                                allowAlphabets2($event, memberVOfirstNm)
                              "
                              [required]="firstNameRequired"
                              #memberVO.firstNm="ngModel"
                            />
                            <mat-error
                              *ngIf="memberVOfirstNm.errors?.['required']"
                              >First Name is required</mat-error
                            >
                            <mat-error
                              *ngIf="memberVOfirstNm.errors?.['invalid']"
                              >First Name is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="memberVOfirstNm.errors?.['pattern']"
                              >First Name is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="memberVOfirstNm.errors?.['nomatch']"
                              >Only Alphabetical, Space, Hyphen, and Apostrophe
                              are allowed</mat-error
                            >
                          </mat-form-field>
                        </div>

                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Last Name<ng-container *ngIf="!lastNameRequired"
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              type="text"
                              name="memberVO.lastNm"
                              [(ngModel)]="memberObj1.lastNm"
                              uppercase
                              maxlength="25"
                              pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                              #memberVOLastNm="ngModel"
                              (keypress)="
                                allowAlphabets2($event, memberVOLastNm)
                              "
                              [required]="lastNameRequired"
                            />
                            <mat-error
                              *ngIf="memberVOLastNm.errors?.['required']"
                              >Last Name is required</mat-error
                            >
                            <mat-error
                              *ngIf="memberVOLastNm.errors?.['invalid']"
                              >Last Name is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="memberVOLastNm.errors?.['pattern']"
                              >Last Name is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="memberVOLastNm.errors?.['nomatch']"
                              >Only Alphabetical, Space, Hyphen, and Apostrophe
                              are allowed</mat-error
                            >
                          </mat-form-field>
                        </div>

                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Social Security Number<ng-container
                                *ngIf="!ssnMemberRequired"
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              type="text"
                              name="memberObj.ssnNum"
                              [(ngModel)]="memberObj1.ssnNum"
                              (input)="
                                memberObj1.ssnNum = ssnmask($event, MemberSsn)
                              "
                              maxlength="11"
                              #MemberSsn="ngModel"
                              (blur)="verifySSN($event, false)"
                              [required]="ssnMemberRequired"
                              pattern="^\d{3}-\d{2}-\d{4}$"
                              (keypress)="isNumeric($event, MemberSsn)"
                            />
                            <mat-error
                              *ngIf="MemberSsn.errors?.['required'] && !MemberSsn.errors?.['nomatch']"
                              >Social Security Number is required</mat-error
                            >
                            <mat-error *ngIf="MemberSsn.errors?.['invalidSsn']"
                              >Social Security Number is invalid</mat-error
                            >
                            <mat-error *ngIf="MemberSsn.errors?.['pattern']">
                              <ng-container
                                *ngIf="memberObj1.ssnNum.length < 11"
                                >Social Security Number length is
                                short</ng-container
                              >
                              <ng-container
                                *ngIf="memberObj1.ssnNum.length > 10"
                                >Social Security Number is invalid</ng-container
                              >
                            </mat-error>
                            <mat-error
                              *ngIf="MemberSsn.errors?.['recordPresent']"
                              >{{ getSSNUsedMessage() }}</mat-error
                            >
                            <mat-error *ngIf="MemberSsn.errors?.['nomatch']"
                              >Only numerical values are allowed</mat-error
                            >
                          </mat-form-field>
                        </div>

                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Date of Birth<ng-container
                                *ngIf="!memberDobRequired"
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              [min]="prev100year"
                              [max]="today"
                              [matDatepicker]="picker"
                              name="d1"
                              #c1="ngModel"
                              [(ngModel)]="memberVOdobDt"
                              [required]="memberDobRequired"
                              minlength="8"
                              maxlength="10"
                              placeholder="MMDDYYYY"
                              (input)="datemask2($event, c1)"
                              (keypress)="onlyNumeric($event, c1)"
                              (blur)="parseDate($event, c1)"
                            />

                            <mat-datepicker-toggle
                              matIconSuffix
                              [for]="picker"
                            ></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                            <mat-error
                              *ngIf="!c1.errors?.['matDatepickerParse'] && c1.errors?.['required'] && !c1.errors?.['nomatch']"
                              >Date of Birth is required</mat-error
                            >
                            <mat-error *ngIf="c1.errors?.['invalid']"
                              >Date of Birth is invalid</mat-error
                            >
                            <mat-error *ngIf="c1.errors?.['matDatepickerMin']"
                              >Date of Birth is out of range</mat-error
                            >
                            <mat-error *ngIf="c1.errors?.['matDatepickerMax']"
                              >Date of Birth is out of range</mat-error
                            >
                            <mat-error *ngIf="c1.errors?.['nomatch']"
                              >Only numerical values are allowed</mat-error
                            >
                            <mat-error *ngIf="c1.errors?.['invalidDate'] || c1.errors?.['matDatepickerParse']"
                              >Date of Birth is invalid</mat-error
                            >
                          </mat-form-field>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col text-center">
                          <mat-error *ngIf="errorMessage != ''">{{
                            errorMessage
                          }}</mat-error>
                          <button
                            id="verifyMemberId"
                            mat-raised-button
                            color="primary"
                            matStepperNext
                            type="button"
                            class="m-1"
                            (click)="verifyMemberFn()"
                          >
                            Verify Member
                          </button>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>

                  <br *ngIf="existingMember == null" />
                  <mat-card
                    *ngIf="existingMember == 'Yes'"
                    class="mat-elevation-z4"
                  >
                    <mat-card-header>
                      <mat-card-subtitle
                        ><mat-label
                          ><strong
                            >Select one:
                            <span class="text-danger">*</span></strong
                          ></mat-label
                        ></mat-card-subtitle
                      >
                    </mat-card-header>
                    <mat-card-content>
                      <mat-radio-group
                        #group
                        color="primary"
                        aria-label="Select an option"
                        [(ngModel)]="updateReason"
                        [required]="updateReasonRequired"
                        name="updateReason"
                        #updateReasons="ngModel"
                        class="example-radio-group"
                      >
                        <mat-radio-button
                          value="CHANGE"
                          [required]="updateReasonRequired"
                          class="example-radio-button"
                        >
                          I am reporting a change in my NVHIPP case
                        </mat-radio-button>
                        <mat-radio-button
                          value="RECERT"
                          [required]="updateReasonRequired"
                          class="example-radio-button"
                        >
                          I am completing my renewal
                        </mat-radio-button>
                      </mat-radio-group>
                      <mat-error
                        *ngIf="updateReasons.errors?.['required'] && customerForm.submitted"
                        >Your response is required</mat-error
                      >
                    </mat-card-content>
                  </mat-card>

                  <div *ngIf="existingMember != null">
                    <div *ngIf="existingMember == 'No'" class="row">
                      <div class="col">
                        <mat-form-field appearance="outline">
                          <mat-label class="fw-bold"
                            >How did you hear about NVHIPP?<ng-container
                              *ngIf="!refferalSourceRequired"
                              >*</ng-container
                            ></mat-label
                          >
                          <select
                            matNativeControl
                            required
                            name="caseVO.sourceCd"
                            [required]="refferalSourceRequired"
                            [(ngModel)]="formNv.referralCase.sourceCd"
                            #RefferralSource="ngModel"
                          >
                            <ng-container
                              *ngIf="preference.dropDownValues != null"
                            >
                              <option
                                *ngFor="
                                  let info of preference.dropDownValues[
                                    'OSRCCD'
                                  ] | keyvalue : originalOrder
                                "
                                [value]="info.key"
                              >
                                {{ info.value }}
                              </option>
                            </ng-container>
                          </select>
                          <mat-error
                            *ngIf="RefferralSource.errors?.['required']"
                            >Source is required</mat-error
                          >
                        </mat-form-field>
                      </div>
                      <div class="col"></div>
                    </div>
                    <br *ngIf="existingMember == 'Yes'" />
                    <mat-card class="mat-elevation-z4">
                      <mat-card-header>
                        <mat-card-subtitle
                          ><strong
                            >Tell us about the Policyholder of the Employer
                            Sponsored Health Insurance or Independent Health
                            Insurance policy.</strong
                          ></mat-card-subtitle
                        >
                      </mat-card-header>
                      <mat-card-content>
                        <br />
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >First Name<ng-container
                                  *ngIf="!firstNameRequired"
                                  >*</ng-container
                                ></mat-label
                              >

                              <input
                                matInput
                                type="text"
                                name="memberVO.firstNm"
                                [(ngModel)]="memberObj1.firstNm"
                                uppercase
                                #memberVOfirstNm="ngModel"
                                pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                                maxlength="20"
                                (keypress)="
                                  allowAlphabets2($event, memberVOfirstNm)
                                "
                                [required]="firstNameRequired"
                                #memberVO.firstNm="ngModel"
                                id="memberFirstName"
                              />
                              <mat-error
                                *ngIf="memberVOfirstNm.errors?.['required']"
                                >First Name is required</mat-error
                              >
                              <mat-error
                                *ngIf="memberVOfirstNm.errors?.['invalid']"
                                >First Name is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="memberVOfirstNm.errors?.['pattern']"
                                >First Name is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="memberVOfirstNm.errors?.['nomatch']"
                                >Only Alphabetical, Space, Hyphen, and
                                Apostrophe are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>MI</mat-label>
                              <input
                                matInput
                                type="text"
                                name="memberVO.miNm"
                                [(ngModel)]="memberObj1.miNm"
                                uppercase
                                maxlength="1"
                                #memberVOMi="ngModel"
                                (keypress)="
                                  allowOnlyOneAlphabet($event, memberVOMi)
                                "
                              />
                              <mat-error *ngIf="memberVOMi.errors?.['invalid']"
                                >Middle Name is invalid</mat-error
                              >
                              <mat-error *ngIf="memberVOMi.errors?.['nomatch']"
                                >Only Alphabet is allowed</mat-error
                              >
                            </mat-form-field>
                          </div>

                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Last Name<ng-container
                                  *ngIf="!lastNameRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input
                                matInput
                                type="text"
                                name="memberVO.lastNm"
                                [(ngModel)]="memberObj1.lastNm"
                                uppercase
                                maxlength="25"
                                pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                                #memberVOLastNm="ngModel"
                                (keypress)="
                                  allowAlphabets2($event, memberVOLastNm)
                                "
                                [required]="lastNameRequired"
                              />
                              <mat-error
                                *ngIf="memberVOLastNm.errors?.['required']"
                                >Last Name is required</mat-error
                              >
                              <mat-error
                                *ngIf="memberVOLastNm.errors?.['invalid']"
                                >Last Name is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="memberVOLastNm.errors?.['pattern']"
                                >Last Name is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="memberVOLastNm.errors?.['nomatch']"
                                >Only Alphabetical, Space, Hyphen, and
                                Apostrophe are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Social Security Number<ng-container
                                  *ngIf="!ssnMemberRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input
                                matInput
                                type="text"
                                name="memberObj.ssnNum"
                                [(ngModel)]="memberObj1.ssnNum"
                                (input)="
                                  memberObj1.ssnNum = ssnmask($event, MemberSsn)
                                "
                                maxlength="11"
                                #MemberSsn="ngModel"
                                (blur)="verifySSN($event, false)"
                                [required]="ssnMemberRequired"
                                pattern="^\d{3}-\d{2}-\d{4}$"
                                (keypress)="isNumeric($event, MemberSsn)"
                                readonly
                              />
                              <mat-error *ngIf="MemberSsn.errors?.['required']"
                                >Social Security Number is required</mat-error
                              >
                              <mat-error
                                *ngIf="MemberSsn.errors?.['invalidSsn']"
                                >Social Security Number is invalid</mat-error
                              >
                              <mat-error *ngIf="MemberSsn.errors?.['pattern']">
                                <ng-container
                                  *ngIf="memberObj1.ssnNum.length < 11"
                                  >Social Security Number length is
                                  short</ng-container
                                >
                                <ng-container
                                  *ngIf="memberObj1.ssnNum.length > 10"
                                  >Social Security Number is
                                  invalid</ng-container
                                >
                              </mat-error>
                              <mat-error
                                *ngIf="MemberSsn.errors?.['recordPresent']"
                                >{{ getSSNUsedMessage() }}</mat-error
                              >
                              <mat-error *ngIf="MemberSsn.errors?.['nomatch']"
                                >Only numerical values are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>

                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Date of Birth<ng-container
                                  *ngIf="!memberDobRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input
                                matInput
                                [min]="prev100year"
                                [max]="today"
                                [matDatepicker]="picker"
                                name="d1"
                                #c1="ngModel"
                                [(ngModel)]="memberVOdobDt"
                                [required]="memberDobRequired"
                                minlength="8"
                                maxlength="10"
                                placeholder="MMDDYYYY"
                                (input)="datemask2($event, c1)"
                                (keypress)="onlyNumeric($event, c1)"
                                (blur)="parseDate($event, c1)"
                                readonly
                              />

                              <mat-datepicker-toggle
                                matIconSuffix
                                [for]="picker"
                                [disabled]="existingMember == 'Yes'"
                              ></mat-datepicker-toggle>
                              <mat-datepicker #picker></mat-datepicker>
                              <mat-error *ngIf="c1.errors?.['required']"
                                >Date of Birth is required</mat-error
                              >
                              <mat-error *ngIf="c1.errors?.['invalid']"
                                >Date of Birth is invalid</mat-error
                              >
                              <mat-error *ngIf="c1.errors?.['matDatepickerMin']"
                                >Date of Birth is out of range</mat-error
                              >
                              <mat-error *ngIf="c1.errors?.['matDatepickerMax']"
                                >Date of Birth is out of range</mat-error
                              >
                              <mat-error *ngIf="c1.errors?.['nomatch']"
                                >Only numerical values are allowed</mat-error
                              >
                              <mat-error *ngIf="c1.errors?.['invalidDate']"
                                >Date of Birth is invalid</mat-error
                              >
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Gender<ng-container
                                  *ngIf="!memberGenderRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <select
                                matNativeControl
                                name="memberVO.gender"
                                [(ngModel)]="memberObj1.gender"
                                #memberObjGencdRf="ngModel"
                                [required]="memberGenderRequired"
                              >
                                <ng-container
                                  *ngIf="preference.dropDownValues != null"
                                >
                                  <option
                                    *ngFor="
                                      let g of preference.dropDownValues[
                                        'GENCD'
                                      ] | keyvalue : originalOrder
                                    "
                                    [value]="g.key"
                                  >
                                    {{ g.value }}
                                  </option>
                                </ng-container>
                              </select>
                              <mat-error
                                *ngIf="memberObjGencdRf.errors?.['required']"
                                >Gender is required</mat-error
                              >
                            </mat-form-field>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <mat-label
                              >Is this person a Medicaid recipient?
                              <span class="text-danger">*</span></mat-label
                            >

                            <mat-radio-group
                              #group
                              color="primary"
                              aria-label="Select an option"
                              [(ngModel)]="isMemberMedicaid"
                              [required]="memberMedicateRequired"
                              name="isMemberMedicaid"
                              (change)="isMedicaidMember()"
                              #isMedicated="ngModel"
                            >
                              <mat-radio-button value="Yes">
                                Yes
                              </mat-radio-button>
                              <mat-radio-button value="No">
                                No
                              </mat-radio-button>
                            </mat-radio-group>
                            <mat-error
                              *ngIf="isMedicated.errors?.['required'] && customerForm.submitted"
                              >Your response is required</mat-error
                            >
                          </div>
                          <div class="col" *ngIf="isMemberMedicaid == 'Yes'">
                            <input
                    type="hidden"
                    name="medicaidRecipient"
                    [(ngModel)]="memberObj1.medicaidRecipient"
                    style="display: none"
                    [value]="isMemberMedicaid == 'Yes'"
                  />
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Medicaid ID Number<ng-container
                                  *ngIf="!maNumRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input
                                matInput
                                type="text"
                                name="memberVO.maNum"
                                [(ngModel)]="memberObj1.maNum"
                                uppercase
                                maxlength="11"
                                pattern="^\d{11}$"
                                #memberVOmaNum="ngModel"
                                (keypress)="isNumeric($event, memberVOmaNum)"
                                [required]="maNumRequired"
                                (blur)="isMedicaidValid($event, memberVOmaNum)"
                              />
                              <mat-error
                                *ngIf="memberVOmaNum.errors?.['required']"
                                >Medicaid ID Number is required</mat-error
                              >
                              <mat-error
                                *ngIf="memberVOmaNum.errors?.['pattern']"
                                >Medicaid ID Number is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="memberVOmaNum.errors?.['invalid']"
                                >Medicaid ID Number is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="memberVOmaNum.errors?.['nomatch']"
                                >Only numerical values are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>
                        </div>
                        <br />
                      </mat-card-content>
                    </mat-card>

                    <br />

                    <mat-card>
                      <mat-card-header>
                        <mat-card-subtitle
                          ><label
                            ><strong> Contact Information </strong>
                          </label></mat-card-subtitle
                        >
                      </mat-card-header>
                      <br />
                      <mat-card-content>
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Primary Phone</mat-label>
                              <input
                                matInput
                                type="text"
                                name="caseVO.phone1Num"
                                [(ngModel)]="formNv.referralCase.phone1Num"
                                (input)="
                                  formNv.referralCase.phone1Num = phonemask2(
                                    $event,
                                    caseVOphone1Num
                                  )
                                "
                                (blur)="phoneCheck($event, caseVOphone1Num)"
                                maxlength="12"
                                pattern="^\d{3}-\d{3}-\d{4}$"
                                (keypress)="isNumeric($event, caseVOphone1Num)"
                                #caseVOphone1Num="ngModel"
                              />
                              <mat-error
                                *ngIf="caseVOphone1Num.errors?.['required']"
                                >Phone Number is required</mat-error
                              >
                              <mat-error
                                *ngIf="caseVOphone1Num.errors?.['invalid']"
                                >Phone Number is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="caseVOphone1Num.errors?.['pattern']"
                                >Phone Number is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="caseVOphone1Num.errors?.['minlength']"
                                >Phone Number is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="caseVOphone1Num.errors?.['nomatch']"
                                >Only numerical values are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>

                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Secondary Phone</mat-label>
                              <input
                                matInput
                                type="text"
                                name="caseVO.phone2Num"
                                [(ngModel)]="formNv.referralCase.phone2Num"
                                (input)="
                                  formNv.referralCase.phone2Num = phonemask2(
                                    $event,
                                    caseVOphone2Num
                                  )
                                "
                                (blur)="phoneCheck($event, caseVOphone2Num)"
                                maxlength="12"
                                pattern="^\d{3}-\d{3}-\d{4}$"
                                (keypress)="isNumeric($event, caseVOphone2Num)"
                                #caseVOphone2Num="ngModel"
                              />
                              <mat-error
                                *ngIf="caseVOphone2Num.errors?.['required']"
                                >Phone Number is required</mat-error
                              >
                              <mat-error
                                *ngIf="caseVOphone2Num.errors?.['invalid']"
                                >Phone Number is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="caseVOphone2Num.errors?.['pattern']"
                                >Phone Number is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="caseVOphone2Num.errors?.['minlength']"
                                >Phone Number is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="caseVOphone2Num.errors?.['nomatch']"
                                >Only numerical values are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Email Address</mat-label>
                              <input
                                matInput
                                type="text"
                                name="caseVO.emailTxt"
                                [(ngModel)]="formNv.referralCase.emailTxt"
                                (blur)="formNv.referralCase.emailTxt = formNv.referralCase.emailTxt.trim()"
                                pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,4}$"
                                maxlength="60"
                                uppercase
                                #caseVOemailTxt="ngModel"
                                email
                              />
                              <mat-error
                                *ngIf="caseVOemailTxt.errors?.['required']"
                                >Email Address is required</mat-error
                              >
                              <mat-error
                                *ngIf="caseVOemailTxt.errors?.['invalid']"
                                >Email Address is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="caseVOemailTxt.errors?.['pattern']"
                                >Email Address format should
                                be name&#64;example.com</mat-error
                              >
                              <mat-error
                                *ngIf="caseVOemailTxt.errors?.['email'] && !caseVOemailTxt.errors?.['pattern']"
                                >Email Address is invalid</mat-error
                              >
                            </mat-form-field>
                          </div>
                        </div>
                      </mat-card-content>
                    </mat-card>
                    <br />
                    <mat-card>
                      <mat-card-header>
                        <mat-card-subtitle
                          ><mat-label
                            ><strong
                              >Residential Address
                              <span class="text-danger">*</span></strong
                            ></mat-label
                          ></mat-card-subtitle
                        >
                      </mat-card-header>
                      <br />
                      <mat-card-content>
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Residential Address<ng-container *ngIf="!resAddress1Required">*</ng-container></mat-label>
                              <input matInput #residentialAddress type="text" name="caseVO.addressLine1Txt" autocomplete="off" #trigger="matAutocompleteTrigger"
                              [required]="resAddress1Required"
                               placeholder="Enter your address" [formControl]="resAddressFormControl.controls.addressLine1Txt"
                               (blur)="validateAddress(resAddressFormControl.controls.addressLine1Txt, resAddressFormControl.controls.cityTxt, resAddressFormControl.controls.stateCd, resAddressFormControl.controls.zipCd)"
                               (keyup)="setDefaultBlank($event,residentialAddress.name, resAddressFormControl,'resAddress')"
                                uppercase  maxlength="50"  [matAutocomplete]="auto" />

                                <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption
                                (optionSelected)="selectSuggestion(resAddressFormControl, residentialAddress.name, resAddressFormControl.controls.addressLine1Txt, $event, trigger, 'resAddress')">
                                  <mat-option *ngFor="let suggestion of addressSuggestions.resAddress" [value]="suggestion">
                                    {{ suggestion.street_line }} {{ suggestion.secondary }} {{ suggestion.city }} {{ suggestion.state }} {{ suggestion.zipcode }}
                                    <span *ngIf="suggestion.entries>'1'" class="sub-address">+{{suggestion.entries}} addresses ></span>
                                  </mat-option>
                                </mat-autocomplete>

                              <mat-error *ngIf="addressSuggestions.resAddress.length == 0 && resAddressFormControl.controls.addressLine1Txt.errors?.['required']">Address is required</mat-error>
                              <mat-error *ngIf="addressSuggestions.resAddress.length == 0 && resAddressFormControl.controls.addressLine1Txt.errors?.['invalid']">Enter valid Address</mat-error>
                              <mat-error *ngIf="resAddressFormControl.controls.addressLine1Txt.errors?.['po']">PO box is not allowed in residential address</mat-error>
                              <mat-error *ngIf="resAddressFormControl.controls.addressLine1Txt.errors?.['nomatch']">Only Alphabets and Numbers are
                                allowed</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col" *ngIf="showResAddress">
                            <mat-form-field appearance="outline">
                              <mat-label>Apartment/Lot</mat-label>
                              <input matInput type="text" name="caseVO.addressLine2Txt"
                              [formControl]="resAddressFormControl.controls.addressLine2Txt" uppercase maxlength="50"
                                readonly />
                              <mat-error *ngIf="resAddressFormControl.controls.addressLine2Txt.errors?.['required']">Address2 is required</mat-error>
                              <mat-error *ngIf="resAddressFormControl.controls.addressLine2Txt.errors?.['invalid']">Address2 is invalid</mat-error>
                              <mat-error *ngIf="resAddressFormControl.controls.addressLine2Txt.errors?.['nomatch']">Only Alphabetical, Space, Hyphen, and Apostrophe are allowed</mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                        <br *ngIf="showResAddress" />
                        <div *ngIf="showResAddress" class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>City<ng-container *ngIf="!resCityRequired">*</ng-container></mat-label>
                              <input matInput type="text" name="caseVO.cityTxt" [formControl]="resAddressFormControl.controls.cityTxt"
                                [required]="resCityRequired" uppercase maxlength="50"
                                readonly />
                              <mat-error *ngIf="resAddressFormControl.controls.cityTxt.errors?.['required']">City is required</mat-error>
                              <mat-error *ngIf="resAddressFormControl.controls.cityTxt.errors?.['invalid']">City is invalid</mat-error>
                              <mat-error *ngIf="resAddressFormControl.controls.cityTxt.errors?.['pattern']">City is invalid</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline" class="disableformfiled">
                              <mat-label class="disableLableColor">State<ng-container
                                  *ngIf="!resStateRequired">*</ng-container></mat-label>
                              <select matNativeControl style="color: rgba(0, 0, 0, 0.87);" name="caseVO.stacdRf"
                                [required]="resStateRequired" aria-label="Default select example"
                                [formControl]="resAddressFormControl.controls.stateCd" >
                                <ng-container *ngIf="preference.dropDownValues != null">
                                  <option *ngFor="
                          let state of preference.dropDownValues['STATECD']
                            | keyvalue : originalOrder
                        " [value]="state.key">
                                    {{ state.value }}
                                  </option>
                                </ng-container>
                              </select>
                              <mat-error *ngIf="resAddressFormControl.controls.stateCd.errors?.['required']">State is required</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Zip Code<ng-container *ngIf="!resZipRequired">*</ng-container></mat-label>
                              <input matInput type="text" name="caseVO.zip5Cd" maxlength="10" minlength="5"
                              [formControl]="resAddressFormControl.controls.zipCd" readonly pattern="(^\d{5}$)|(^\d{5}-\d{4}$)"
                                 [required]="resZipRequired" />
                              <mat-error *ngIf="resAddressFormControl.controls.zipCd.errors?.['required']">Zip Code is required</mat-error>
                              <mat-error *ngIf="resAddressFormControl.controls.zipCd.errors?.['invalid']">Zip Code is invalid</mat-error>
                              <mat-error *ngIf="resAddressFormControl.controls.zipCd.errors?.['pattern']">Zip Code is invalid</mat-error>
                              <mat-error *ngIf="resAddressFormControl.controls.zipCd.errors?.['nomatch']">Only numerical values are
                                allowed</mat-error>

                            </mat-form-field>
                          </div>
                        </div>
                        <br />
                      </mat-card-content>
                    </mat-card>
                    <br />
                    <div class="row">
                      <div class="col">
                        <mat-label
                          >Is physical and mailing address the same?
                          <span class="text-danger">*</span></mat-label
                        >

                        <mat-radio-group
                          #group
                          aria-label="Select an option"
                          [(ngModel)]="isSameMailingAddress"
                          [required]="isSameRequired"
                          name="isSameMailingAddress"
                          #isSameMailing="ngModel"
                          (click)="sameMailingAddress()"
                        >
                          <mat-radio-button
                            value="Yes"
                            [required]="isSameRequired"
                          >
                            Yes
                          </mat-radio-button>
                          <mat-radio-button
                            value="No"
                            [required]="isSameRequired"
                            checked="true"
                          >
                            No
                          </mat-radio-button>
                        </mat-radio-group>
                      </div>
                      <mat-error
                        *ngIf="isSameMailing.errors?.['required'] && customerForm.submitted"
                        >Your response is required</mat-error
                      >
                    </div>
                    <br />
                    <mat-card *ngIf="isSameMailingAddress == 'No'">
                      <mat-card-header>
                        <mat-card-subtitle
                          ><mat-label
                            ><strong
                              >Mailing Address
                              <span class="text-danger">*</span></strong
                            ></mat-label
                          ></mat-card-subtitle
                        >
                      </mat-card-header>
                      <br />
                      <mat-card-content>
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Mailing Address<ng-container
                                  *ngIf="!mailAddress1Required">*</ng-container></mat-label>
                                <input matInput #mailingAddress type="text" name="mailAddress.addressLine1Txt" autocomplete="off" #trigger1="matAutocompleteTrigger"
                                (blur)="validateAddress(mailAddressFormControl.controls.addressLine1Txt, mailAddressFormControl.controls.cityTxt, mailAddressFormControl.controls.stateCd, mailAddressFormControl.controls.zipCd)"
                                (keyup)="setDefaultBlank($event,mailingAddress.name, mailAddressFormControl, 'mailAddress')" placeholder="Enter your address"
                                (focus)="onFocusInput()" [required]="mailAddress1Required"
                                [formControl]="mailAddressFormControl.controls.addressLine1Txt"
                                 uppercase maxlength="50"  [matAutocomplete]="auto" />
                                 <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption
                                 (optionSelected)="selectSuggestion(mailAddressFormControl, mailingAddress.name, mailAddressFormControl.controls.addressLine1Txt, $event, trigger1, 'mailAddress')">
                                   <mat-option *ngFor="let suggestion of addressSuggestions.mailAddress" [value]="suggestion">
                                     {{ suggestion.street_line }} {{ suggestion.secondary }} {{ suggestion.city }} {{ suggestion.state }} {{ suggestion.zipcode }}
                                     <span *ngIf="suggestion.entries>'1'" class="sub-address">+{{suggestion.entries}} addresses ></span>
                                   </mat-option>
                                 </mat-autocomplete>
                                <mat-error *ngIf="mailAddressFormControl.controls.addressLine1Txt.errors?.['required']">Address is required</mat-error>
                                <mat-error *ngIf="mailAddressFormControl.controls.addressLine1Txt.errors?.['invalid']">Enter valid Address</mat-error>
                                <mat-error *ngIf="mailAddressFormControl.controls.addressLine1Txt.errors?.['nomatch']">Only Alphabets and Numbers are
                                  allowed</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col" *ngIf="showMailAddress">
                            <mat-form-field appearance="outline">
                              <mat-label>Apartment/Lot</mat-label>
                              <input matInput type="text" name="mailAddress.addressLine2Txt"
                                [formControl]="mailAddressFormControl.controls.addressLine2Txt" uppercase maxlength="50"
                                readonly />
                              <mat-error *ngIf="mailAddressFormControl.controls.addressLine2Txt.errors?.['required']">Address2 is required</mat-error>
                              <mat-error *ngIf="mailAddressFormControl.controls.addressLine2Txt.errors?.['invalid']">Address2 is invalid</mat-error>
                              <mat-error *ngIf="mailAddressFormControl.controls.addressLine2Txt.errors?.['nomatch']">Only Alphabetical, Space, Hyphen, and Apostrophe are allowed.</mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                        <br />
                        <div
                          *ngIf="
                            isSameMailingAddress == 'No' && showMailAddress
                          "
                          class="row"
                        >
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>City<ng-container *ngIf="!mailCityRequired">*</ng-container></mat-label>
                              <input matInput type="text" name="mailAddress.cityTxt" [formControl]="mailAddressFormControl.controls.cityTxt"
                                [required]="mailCityRequired" uppercase  maxlength="50"
                                readonly />
                              <mat-error *ngIf="mailAddressFormControl.controls.cityTxt.errors?.['required']">City is required</mat-error>
                              <mat-error *ngIf="mailAddressFormControl.controls.cityTxt.errors?.['invalid']">City is invalid</mat-error>
                              <mat-error *ngIf="mailAddressFormControl.controls.cityTxt.errors?.['pattern']">City is invalid</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline" class="disableformfiled">
                              <mat-label class="disableLableColor">State<ng-container
                                  *ngIf="!mailStateRequired">*</ng-container></mat-label>
                              <select matNativeControl style="color: rgba(0, 0, 0, 0.87);" name="mailAddress.stacdRf"
                                [required]="mailStateRequired" [disabled]= "true" aria-label="Default select example"
                                [formControl]="mailAddressFormControl.controls.stateCd" readonly >
                                <ng-container *ngIf="preference.dropDownValues != null">
                                  <option *ngFor="
                          let state of preference.dropDownValues['STATECD']
                            | keyvalue : originalOrder
                        " [value]="state.key">
                                    {{ state.value }}
                                  </option>
                                </ng-container>
                              </select>
                              <mat-error *ngIf="mailAddressFormControl.controls.stateCd.errors?.['required']">State is required</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>Zip Code<ng-container *ngIf="!mailZipRequired">*</ng-container></mat-label>
                              <input matInput type="text" name="mailing.zip5Cd" maxlength="10" minlength="5"
                              [formControl]="mailAddressFormControl.controls.zipCd" pattern="(^\d{5}$)|(^\d{5}-\d{4}$)"
                                 [required]="mailZipRequired" readonly />
                              <mat-error *ngIf="mailAddressFormControl.controls.zipCd.errors?.['required']">Zip Code is required</mat-error>
                              <mat-error *ngIf="mailAddressFormControl.controls.zipCd.errors?.['invalid']">Zip Code is invalid</mat-error>
                              <mat-error *ngIf="mailAddressFormControl.controls.zipCd.errors?.['pattern']">Zip Code is invalid</mat-error>
                              <mat-error *ngIf="mailAddressFormControl.controls.zipCd.errors?.['nomatch']">Only numerical values are
                                allowed</mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </mat-card-content>
                    </mat-card>
                    <br />
                  </div>
                  <div
                    class="d-grid gap-2 d-md-flex justify-content-md-end"
                    *ngIf="existingMember != null"
                  >
                    <button
                      mat-raised-button
                      color="primary"
                      matStepperNext
                      (click)="farword()"
                      [disabled]="existingMember == null"
                    >
                      Next
                    </button>
                  </div>
                </fieldset>
              </mat-step>
              <mat-step
                label="Employer/Policy"
                aria-label="Employer/Policy"
                [completed]="employerPolicyCheck()"
              >
                <fieldset
                  class="shadow p-5 mb-1 rounded-5"
                  style="border: 2px solid #63b1bc"
                >
                  <legend
                    class="float-none w-auto p-1 mx-5 fw-bold fs-1"
                    style="color: #003057"
                  >
                    Apply Now
                  </legend>

                  <div class="row">
                    <div class="col"></div>
                  </div>
                  <mat-card class="mat-elevation-z4">
                    <mat-card-header>
                      <mat-card-subtitle
                        ><label
                          ><strong>
                            Tell us about the employer or insurance company that
                            offers health insurance coverage.
                          </strong>
                        </label></mat-card-subtitle
                      >
                    </mat-card-header>
                    <mat-card-content>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-label
                            >Is this health insurance through?<span
                              class="text-danger"
                              >*</span
                            ></mat-label
                          >
                          <mat-radio-group
                            #group
                            aria-label="Select an option"
                            [(ngModel)]="formNv.referralPolicy.policySourceCd"
                            #sourceCd="ngModel"
                            name="isHealthInsurance"
                            [required]="sourceCdRequired"
                          >
                            <mat-radio-button
                              value="E"
                              [required]="sourceCdRequired"
                            >
                              Employer
                            </mat-radio-button>
                            <mat-radio-button
                              value="S"
                              [required]="sourceCdRequired"
                            >
                              Self-Insured
                            </mat-radio-button>
                            <!-- <mat-radio-button value="M" [required]="sourceCdRequired">
                              Marketplace
                            </mat-radio-button> -->
                          </mat-radio-group>
                          <mat-error
                            *ngIf="sourceCd.errors?.['required'] && customerForm.submitted"
                            >Your response is required</mat-error
                          >
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Employer or Company Name<ng-container
                                *ngIf="
                                  existingMember == 'No' && !eplyrNmRequired
                                "
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              type="text"
                              name="employerVO.emplyrNm"
                              [(ngModel)]="formNv.referralEmployer.emplyrNm"
                              maxlength="100"
                              uppercase
                              pattern="^(?![ -\/]).+"
                              [required]="eplyrNmRequired"
                              (keypress)="allowAlphaNumericWithSplChar($event)"
                              #emplyrNm="ngModel"
                            />
                            <mat-error *ngIf="emplyrNm.errors?.['required']"
                              >Employer Name is required</mat-error
                            >
                            <mat-error *ngIf="emplyrNm.errors?.['pattern']"
                              >Employer Name is invalid</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Human Resources Contact Number<ng-container
                                *ngIf="
                                  existingMember == 'No' && !emplyrPhoneRequired
                                "
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              type="text"
                              name="employerVO.phone1Num"
                              [(ngModel)]="formNv.referralEmployer.phoneNum"
                              maxlength="12"
                              pattern="^\d{3}-\d{3}-\d{4}$"
                              [required]="emplyrPhoneRequired"
                              (input)="
                                formNv.referralEmployer.phoneNum = phonemask2(
                                  $event,
                                  employerphone1Num
                                )
                              "
                              (blur)="phoneCheck($event, employerphone1Num)"
                              (keypress)="isNumeric($event, employerphone1Num)"
                              #employerphone1Num="ngModel"
                            />
                            <mat-error
                              *ngIf="employerphone1Num.errors?.['invalid']"
                              >Human Resources Contact Number is
                              invalid</mat-error
                            >
                            <mat-error
                              *ngIf="employerphone1Num.errors?.['pattern']"
                              >Human Resources Contact Number is
                              invalid</mat-error
                            >
                            <mat-error
                              *ngIf="employerphone1Num.errors?.['minlength']"
                              >Human Resources Contact Number is
                              invalid</mat-error
                            >
                            <mat-error
                              *ngIf="employerphone1Num.errors?.['required']"
                              >Human Resources Contact Number is
                              required</mat-error
                            >
                            <mat-error
                              *ngIf="employerphone1Num.errors?.['nomatch']"
                              >Only numerical values are allowed</mat-error
                            >
                          </mat-form-field>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Address<ng-container
                                *ngIf="existingMember =='No' && !emplyrAddr1Required">*</ng-container></mat-label>
                                <input matInput type="text" #emplyrAddress name="employerVO.addressLine1Txt" autocomplete="off" #trigger2="matAutocompleteTrigger"
                                (focus)="onFocusInput()"
                                (blur)="validateAddress(referralEmployerAddressFormControl.controls.addressLine1Txt, referralEmployerAddressFormControl.controls.cityTxt, referralEmployerAddressFormControl.controls.stateCd, referralEmployerAddressFormControl.controls.zipCd)"
                                  (keyup)="setDefaultBlank($event, emplyrAddress.name, referralEmployerAddressFormControl, 'referralEmployerAddress')"
                                  placeholder="Enter your address" [required]="emplyrAddr1Required"
                                  [formControl]="referralEmployerAddressFormControl.controls.addressLine1Txt"
                                  uppercase  maxlength="50"  [matAutocomplete]="auto2" />
                                    <mat-autocomplete #auto2="matAutocomplete"  autoActiveFirstOption
                                    (optionSelected)="selectSuggestion(referralEmployerAddressFormControl, emplyrAddress.name, referralEmployerAddressFormControl.controls.addressLine1Txt, $event, trigger2, 'referralEmployerAddress')">
                                      <mat-option *ngFor="let suggestion of addressSuggestions.referralEmployerAddress" [value]="suggestion">
                                        {{ suggestion.street_line }} {{ suggestion.secondary }} {{ suggestion.city }} {{ suggestion.state }} {{ suggestion.zipcode }}
                                        <span *ngIf="suggestion.entries>'1'" class="sub-address">+{{suggestion.entries}} addresses ></span>
                                      </mat-option>
                                    </mat-autocomplete>
                            <mat-error *ngIf="referralEmployerAddressFormControl.controls.addressLine1Txt.errors?.['required']">Employer Address is required</mat-error>
                            <mat-error *ngIf="referralEmployerAddressFormControl.controls.addressLine1Txt.errors?.['invalid']">Enter valid Address</mat-error>
                            <mat-error *ngIf="mailAddressFormControl.controls.addressLine1Txt.errors?.['nomatch']">Only Alphabets and Numbers are
                              allowed</mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col" *ngIf="showEmployerAddress">
                          <mat-form-field appearance="outline">
                            <mat-label>Suite/Unit</mat-label>
                            <input matInput type="text" name="employerVO.addressLine2Txt"
                            [formControl]="referralEmployerAddressFormControl.controls.addressLine2Txt" uppercase maxlength="40"
                              readonly />
                            <mat-error *ngIf="referralEmployerAddressFormControl.controls.addressLine2Txt.errors?.['required']">Employer Suite/Unit is
                              required</mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <br *ngIf="showEmployerAddress" />
                      <div class="row" *ngIf="showEmployerAddress">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >City<ng-container
                                *ngIf="
                                  existingMember == 'No' && !emplyrCityRequired
                                "
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              type="text"
                              name="employerVO.cityTxt"
                              [required]="emplyrCityRequired"
                              [(ngModel)]="formNv.referralEmployer.cityTxt"
                              uppercase
                              #empVoCity="ngModel"
                              maxlength="20"
                              readonly
                            />
                            <mat-error *ngIf="empVoCity.errors?.['invalid']"
                              >City is invalid</mat-error
                            >
                            <mat-error *ngIf="empVoCity.errors?.['pattern']"
                              >City is invalid</mat-error
                            >
                            <mat-error *ngIf="empVoCity.errors?.['required']"
                              >City is required</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field
                            appearance="outline"
                            class="disableformfiled"
                          >
                            <mat-label class="disableLableColor"
                              >State<ng-container
                                *ngIf="
                                  existingMember == 'No' && !emplyrStateRequired
                                "
                                >*</ng-container
                              ></mat-label
                            >
                            <select
                              matNativeControl
                              style="color: rgba(0, 0, 0, 0.87)"
                              name="employerVO.stacdRf"
                              [(ngModel)]="formNv.referralEmployer.stateCd"
                              aria-label="Default select example"
                              [required]="emplyrStateRequired"
                              #emplyrState="ngModel"
                              disabled
                            >
                              <ng-container
                                *ngIf="preference.dropDownValues != null"
                              >
                                <option
                                  *ngFor="
                                    let state of preference.dropDownValues[
                                      'STATECD'
                                    ] | keyvalue : originalOrder
                                  "
                                  [value]="state.key"
                                >
                                  {{ state.value }}
                                </option>
                              </ng-container>
                            </select>
                            <mat-error *ngIf="emplyrState.errors?.['required']"
                              >State is required</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Zip Code<ng-container
                                *ngIf="
                                  existingMember == 'No' &&
                                  !emplyrZipCodeRequired
                                "
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              type="text"
                              name="employerVO.zip5Cd"
                              [(ngModel)]="formNv.referralEmployer.zipCd"
                              minlength="5"
                              maxlength="10"
                              [required]="emplyrZipCodeRequired"
                              pattern="(^\d{5}$)|(^\d{5}-\d{4}$)"
                              #employerAddressZipCd="ngModel"
                              readonly
                            />
                            <mat-error
                              *ngIf="employerAddressZipCd.errors?.['invalid']"
                              >Zip Code is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="employerAddressZipCd.errors?.['pattern']"
                              >Zip Code is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="employerAddressZipCd.errors?.['required']"
                              >Zip Code is required</mat-error
                            >
                            <mat-error
                              *ngIf="employerAddressZipCd.errors?.['nomatch']"
                              >Only numerical values are allowed</mat-error
                            >
                          </mat-form-field>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Employer FEIN (Tax ID)<ng-container
                                *ngIf="
                                  existingMember == 'No' && !emplyrFeinRequired
                                "
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              type="text"
                              name="employerVO.emplyrFein"
                              [(ngModel)]="formNv.referralEmployer.emplyrFein"
                              minlength="10"
                              maxlength="10"
                              (keypress)="isNumeric($event, empFEINValue)"
                              (input)="
                                formNv.referralEmployer.emplyrFein =
                                  empFEINMask($event, empFEINValue)
                              "
                              pattern="(^\d{2}-\d{7}$)"
                              #empFEINValue="ngModel"
                              [required]="emplyrFeinRequired"
                              (blur)="isFEINValidValue($event, empFEINValue)"
                            />
                            <mat-error *ngIf="empFEINValue.errors?.['invalid']"
                              >Employer FEIN is invalid</mat-error
                            >
                            <mat-error *ngIf="empFEINValue.errors?.['pattern']"
                              >Employer FEIN is invalid</mat-error
                            >
                            <mat-error *ngIf="empFEINValue.errors?.['required']"
                              >Employer FEIN is required</mat-error
                            >
                            <mat-error *ngIf="empFEINValue.errors?.['nomatch']"
                              >Only numerical values are allowed</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Next Open Enrollment Start Date<ng-container
                                *ngIf="
                                  existingMember == 'No' &&
                                  !emplyrEnrollmentStartRequired
                                "
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              [matDatepicker]="picker8"
                              name="d8"
                              #c8="ngModel"
                              [required]="emplyrEnrollmentStartRequired"
                              [(ngModel)]="openenrollmentstartdate"
                              [min]="today"
                              [max]="plus1year"
                              minlength="8"
                              maxlength="10"
                              placeholder="MMDDYYYY"
                              (input)="datemask2($event, c8)"
                              (keypress)="onlyNumeric($event, c8)"
                              (ngModelChange)="compareDate(c8, c9)"
                              (blur)="parseDate($event, c8)"
                            />

                            <mat-datepicker-toggle
                              matIconSuffix
                              [for]="picker8"
                            ></mat-datepicker-toggle>
                            <mat-datepicker #picker8></mat-datepicker>

                            <mat-error *ngIf="c8.errors?.['invalid']"
                              >Enrollment start date is invalid</mat-error
                            >
                            <mat-error *ngIf="c8.errors?.['matDatepickerMin']"
                              >Enrollment start date is out of range</mat-error
                            >
                            <mat-error *ngIf="c8.errors?.['matDatepickerMax']"
                              >Enrollment start date is out of range</mat-error
                            >
                            <mat-error *ngIf="c8.errors?.['nomatch']"
                              >Only numerical values are allowed</mat-error
                            >
                            <mat-error *ngIf="c8.errors?.['invalidDate']"
                              >Enrollment start date is invalid</mat-error
                            >
                            <mat-error *ngIf="c8.errors?.['required']"
                              >Enrollment start date is required</mat-error
                            >
                            <mat-error *ngIf="c8.errors?.['invalidEndDate']"
                              >Enrollment start date should not be greater than
                              end date</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Next Open Enrollment End Date<ng-container
                                *ngIf="
                                  existingMember == 'No' &&
                                  !emplyrEnrollmentStartRequired
                                "
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              [matDatepicker]="picker9"
                              name="d9"
                              #c9="ngModel"
                              [required]="emplyrEnrollmentEndRequired"
                              [(ngModel)]="openenrollmentenddate"
                              [min]="openenrollmentstartdate"
                              [max]="plus1year"
                              minlength="8"
                              maxlength="10"
                              placeholder="MMDDYYYY"
                              (input)="datemask2($event, c9)"
                              (ngModelChange)="compareDate(c9, c8)"
                              (keypress)="onlyNumeric($event, c9)"
                              (blur)="parseDate($event, c9)"
                            />

                            <mat-datepicker-toggle
                              matIconSuffix
                              [for]="picker9"
                            ></mat-datepicker-toggle>
                            <mat-datepicker #picker9></mat-datepicker>

                            <mat-error *ngIf="c9.errors?.['invalid']"
                              >Enrollment end date is invalid</mat-error
                            >
                            <mat-error *ngIf="c9.errors?.['matDatepickerMin']"
                              >Enrollment end date is out of range</mat-error
                            >
                            <mat-error *ngIf="c9.errors?.['matDatepickerMax']"
                              >Enrollment end date is out of range</mat-error
                            >
                            <mat-error *ngIf="c9.errors?.['nomatch']"
                              >Only numerical values are allowed</mat-error
                            >
                            <mat-error *ngIf="c9.errors?.['invalidDate']"
                              >Enrollment end date is invalid</mat-error
                            >
                            <mat-error *ngIf="c9.errors?.['required']"
                              >Enrollment end date is required</mat-error
                            >
                            <mat-error *ngIf="c9.errors?.['invalidEndDate']"
                              >Enrollment end date should not be less than start
                              date</mat-error
                            >
                          </mat-form-field>
                        </div>
                      </div>
                      <br>
                    </mat-card-content>
                  </mat-card>
                  <br />
                  <mat-card class="mat-elevation-z4">
                    <mat-card-header>
                      <mat-card-subtitle
                        ><label
                          ><strong>
                            Tell us about the health insurance plan that the
                            Policyholder is currently enrolled in or has access
                            to.
                          </strong>
                        </label>
                      </mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Health Insurance Company Name</mat-label>
                            <input
                              matInput
                              type="text"
                              name="policyVO.carrierNm"
                              [(ngModel)]="formNv.referralPolicy.carrierNm"
                              uppercase
                              maxlength="40"
                              (blur)="validateCarrierNm($event,policyVOcarrierNm)"
                              (keypress)="allowAlphaNumericForCarrier($event,policyVOcarrierNm)"
                              #policyVOcarrierNm="ngModel"
                            />
                            <mat-error
                              *ngIf="policyVOcarrierNm.errors?.['required']"
                              >Company name is required</mat-error
                            >
                            <mat-error
                              *ngIf="policyVOcarrierNm.errors?.['nomatch']"
                              >This field only allows - ( ) / space, alphanumeric characters and cannot end with a special character or space</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Contact Number</mat-label>
                            <input
                              matInput
                              type="text"
                              name="policyVO.phoneNum"
                              [(ngModel)]="formNv.referralPolicy.phoneNum"
                              maxlength="12"
                              pattern="^\d{3}-\d{3}-\d{4}$"
                              (input)="
                                formNv.referralPolicy.phoneNum = phonemask2(
                                  $event,
                                  policyVoPhoneNum
                                )
                              "
                              (blur)="phoneCheck($event, policyVoPhoneNum)"
                              (keypress)="isNumeric($event, policyVoPhoneNum)"
                              #policyVoPhoneNum="ngModel"
                            />
                            <mat-error
                              *ngIf="policyVoPhoneNum.errors?.['invalid']"
                              >Contact Number is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="policyVoPhoneNum.errors?.['pattern']"
                              >Contact Number is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="policyVoPhoneNum.errors?.['minlength']"
                              >Contact Number is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="policyVoPhoneNum.errors?.['nomatch']"
                              >Only numerical values are allowed</mat-error
                            >
                          </mat-form-field>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Health Insurance Company Address</mat-label>
                            <input matInput type="text" #policyAddress name="policyVO.addressLine1Txt" autocomplete="off"
                            (focus)="onFocusInput()"
                            (blur)="validateAddress(referralPolicyAddressFormControl.controls.addressLine1Txt, referralPolicyAddressFormControl.controls.cityTxt, referralPolicyAddressFormControl.controls.stateCd, referralPolicyAddressFormControl.controls.zipCd)"
                            (keyup)="setDefaultBlank($event, policyAddress.name, referralPolicyAddressFormControl,'referralPolicyAddress')"
                            placeholder="Enter your address" #trigger3="matAutocompleteTrigger"
                            [formControl]="referralPolicyAddressFormControl.controls.addressLine1Txt"
                             uppercase maxlength="50"  [matAutocomplete]="auto1" />

                              <mat-autocomplete #auto1="matAutocomplete" autoActiveFirstOption
                              (optionSelected)="selectSuggestion(referralPolicyAddressFormControl, policyAddress.name, referralPolicyAddressFormControl.controls.addressLine1Txt, $event, trigger3,'referralPolicyAddress')">
                                <mat-option *ngFor="let suggestion of addressSuggestions.referralPolicyAddress" [value]="suggestion">
                                  {{ suggestion.street_line }} {{ suggestion.secondary }} {{ suggestion.city }} {{ suggestion.state }} {{ suggestion.zipcode }}
                                  <span *ngIf="suggestion.entries>'1'" class="sub-address">+{{suggestion.entries}} addresses ></span>
                                </mat-option>
                              </mat-autocomplete>
                            <mat-error *ngIf="referralPolicyAddressFormControl.controls.addressLine1Txt.errors?.['invalid']">Enter valid Address</mat-error>
                            <mat-error *ngIf="referralPolicyAddressFormControl.controls.addressLine1Txt.errors?.['nomatch']">Only Alphabets and Numbers are
                              allowed</mat-error>
                        </mat-form-field>
                        </div>

                        <div class="col" *ngIf="showPolicyAddress">
                          <mat-form-field appearance="outline">
                            <mat-label>Suite/Unit</mat-label>
                            <input matInput type="text" name="policyVO.addressLine2Txt"
                            [formControl]="referralPolicyAddressFormControl.controls.addressLine2Txt" uppercase maxlength="40" readonly />
                          </mat-form-field>
                        </div>
                      </div>
                      <br *ngIf="showPolicyAddress" />

                      <div class="row" *ngIf="showPolicyAddress">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>City</mat-label>
                            <input matInput type="text" name="policyVO.cityTxt"
                            [formControl]="referralPolicyAddressFormControl.controls.cityTxt" uppercase maxlength="40"
                              readonly />
                            <mat-error *ngIf="referralPolicyAddressFormControl.controls.cityTxt.errors?.['invalid']">City is invalid</mat-error>
                            <mat-error *ngIf="referralPolicyAddressFormControl.controls.cityTxt.errors?.['pattern']">City is invalid</mat-error>
                            <mat-error *ngIf="referralPolicyAddressFormControl.controls.cityTxt.errors?.['required']">City is required</mat-error>
                            <mat-error *ngIf="referralPolicyAddressFormControl.controls.cityTxt.errors?.['nomatch']">Only Alphabetical, Space, Hyphen, and Apostrophe are allowed.</mat-error>
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field
                            appearance="outline"
                            class="disableformfiled"
                          >
                            <mat-label class="disableLableColor"
                              >State</mat-label
                            >
                            <select
                              matNativeControl
                              style="color: rgba(0, 0, 0, 0.87)"
                              name="policyVO.stacdRf"
                              [(ngModel)]="formNv.referralPolicy.stateCd"
                              aria-label="Default select example"
                              [required]="policyStateRequired"
                              #policyState="ngModel"
                              disabled
                            >
                              <ng-container
                                *ngIf="preference.dropDownValues != null"
                              >
                                <option
                                  *ngFor="
                                    let state of preference.dropDownValues[
                                      'STATECD'
                                    ] | keyvalue : originalOrder
                                  "
                                  [value]="state.key"
                                >
                                  {{ state.value }}
                                </option>
                              </ng-container>
                            </select>
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Zip Code</mat-label>
                            <input
                              matInput
                              type="text"
                              name="policyVO.zip5Cd"
                              [(ngModel)]="formNv.referralPolicy.zipCd"
                              minlength="5"
                              maxlength="10"
                              pattern="(^\d{5}$)|(^\d{5}-\d{4}$)"
                              #policyVOZipCode="ngModel"
                              readonly
                            />
                            <mat-error
                              *ngIf="policyVOZipCode.errors?.['invalid']"
                              >Zip Code is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="policyVOZipCode.errors?.['pattern']"
                              >Zip Code is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="policyVOZipCode.errors?.['nomatch']"
                              >Only numerical values are allowed</mat-error
                            >
                          </mat-form-field>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Health Insurance Plan Name</mat-label>
                            <input
                              matInput
                              type="text"
                              name="policyVO.planNm"
                              [(ngModel)]="formNv.referralPolicy.planNm"
                              maxlength="100"
                              uppercase
                              (keypress)="allowAlphaNumericWithSplChars($event,policyPlanNm)"
                              (blur)="validatePlanNm($event,policyPlanNm)"
                              #policyPlanNm="ngModel"
                            />
                            <mat-error *ngIf="policyPlanNm.errors?.['nomatch']"
                              >This field only allows - / # & space, alphanumeric characters and cannot end with a special character or space</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Policy ID Number</mat-label>
                            <input
                              matInput
                              type="text"
                              name="policyVO.policyNum"
                              [(ngModel)]="formNv.referralPolicy.policyNum"
                              uppercase
                              maxlength="20"
                              (keypress)="allowAlphaNumericWithoutSpace($event,policyId)"
                              #policyId="ngModel"
                              (blur)="validatePolicyId($event,policyId)"
                            />
                            <mat-error *ngIf="policyId.errors?.['nomatch']"
                            >This field only allows alphanumeric characters</mat-error
                          >
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Group Number</mat-label>
                            <input
                              matInput
                              type="text"
                              name="policyVO.groupNum"
                              [(ngModel)]="formNv.referralPolicy.groupNum"
                              uppercase
                              maxlength="15"
                              (blur)="validateGroupNum($event,policyGroupNum)"
                              (keypress)="allowAlphaNumericWithTwoSplChar($event,policyGroupNum)"
                              #policyGroupNum="ngModel"
                            />
                            <mat-error
                            *ngIf="policyGroupNum.errors?.['nomatch']"
                            >This field only allows alphanumeric characters, space, - and cannot end with a special character or space</mat-error
                          >
                          </mat-form-field>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Policy Start Date</mat-label>
                            <input
                              matInput
                              [matDatepicker]="picker3"
                              [min]="prev10year"
                              [max]="next5year"
                              name="d3"
                              #c3="ngModel"
                              [(ngModel)]="policyVOpolicyStartDate"
                              minlength="8"
                              maxlength="10"
                              placeholder="MMDDYYYY"
                              (input)="datemask2($event, c3)"
                              (keypress)="onlyNumeric($event, c3)"
                              (blur)="parseDate($event, c3)"
                            />

                            <mat-datepicker-toggle
                              matIconSuffix
                              [for]="picker3"
                            ></mat-datepicker-toggle>
                            <mat-datepicker #picker3></mat-datepicker>
                            <mat-error *ngIf="c3.errors?.['minlength']"
                              >Policy start date is invalid</mat-error
                            >
                            <mat-error *ngIf="c3.errors?.['invalid']"
                              >Policy start date is invalid</mat-error
                            >
                            <mat-error *ngIf="c3.errors?.['matDatepickerMin']"
                              >Policy start date out of range</mat-error
                            >
                            <mat-error *ngIf="c3.errors?.['matDatepickerMax']"
                              >Policy start date out of range</mat-error
                            >
                            <mat-error *ngIf="c3.errors?.['nomatch']"
                              >Only numerical values are allowed</mat-error
                            >
                            <mat-error *ngIf="c3.errors?.['invalidDate']"
                              >Policy start date is invalid</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Premium Amount<ng-container
                                *ngIf="
                                  existingMember == 'Yes' &&
                                  !premiumAmountRequired
                                "
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              type="text"
                              name="premium"
                              [(ngModel)]="
                                formNv.referralPolicy.employeePremium
                              "
                              #policyVOempyPremium="ngModel"
                              maxlength="8"
                              min="0"
                              pattern="^[0-9]{1,7}(\.[0-9]{0,2})?$"
                              (input)="
                                formNv.referralPolicy.employeePremium =
                                  amountMask($event, policyVOempyPremium)
                              "
                              (blur)="
                                validatePremiumAmount(
                                  $event,
                                  policyVOempyPremium
                                )
                              "
                              [required]="premiumAmountRequired"
                            />
                            <span matTextPrefix>$&nbsp;</span>
                            <mat-error
                              *ngIf="policyVOempyPremium.errors?.['required']"
                              >Premium Amount is required</mat-error
                            >
                            <mat-error
                              *ngIf="policyVOempyPremium.errors?.['invalid']"
                              >Premium Amount is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="policyVOempyPremium.errors?.['nomatch']"
                              >Premium Amount is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="policyVOempyPremium.errors?.['pattern']"
                              >Premium Amount is invalid</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Yearly Single Deductible<ng-container
                                *ngIf="
                                  existingMember == 'Yes' &&
                                  !singleDeductibleRequired
                                "
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              type="text"
                              name="Single Deductible"
                              [(ngModel)]="
                                formNv.referralPolicy.individualMaxDeductible
                              "
                              #SingleDeductible="ngModel"
                              maxlength="8"
                              min="0"
                              pattern="^[0-9]{1,7}(\.[0-9]{0,2})?$"
                              (input)="
                                formNv.referralPolicy.individualMaxDeductible =
                                  amountMask($event, SingleDeductible)
                              "
                              (blur)="
                                validatePremiumAmount($event, SingleDeductible)
                              "
                              [required]="singleDeductibleRequired"
                            />
                            <span matTextPrefix>$&nbsp;</span>
                            <mat-error
                              *ngIf="SingleDeductible.errors?.['required']"
                              >Yearly Single Deductible is required</mat-error
                            >
                            <mat-error
                              *ngIf="SingleDeductible.errors?.['invalid']"
                              >Yearly Single Deductible is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="SingleDeductible.errors?.['nomatch']"
                              >Yearly Single Deductible is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="SingleDeductible.errors?.['pattern']"
                              >Yearly Single Deductible is invalid</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Yearly Family Deductible<ng-container
                                *ngIf="
                                  existingMember == 'Yes' &&
                                  !familyDeductibleRequired
                                "
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              type="text"
                              name="Family Deductible"
                              [(ngModel)]="
                                formNv.referralPolicy.familyMaxDeductible
                              "
                              #FamilyDeductible="ngModel"
                              maxlength="8"
                              min="0"
                              pattern="^[0-9]{1,7}(\.[0-9]{0,2})?$"
                              (input)="
                                formNv.referralPolicy.familyMaxDeductible =
                                  amountMask($event, FamilyDeductible)
                              "
                              (blur)="
                                validatePremiumAmount($event, FamilyDeductible)
                              "
                              [required]="familyDeductibleRequired"
                            />
                            <span matTextPrefix>$&nbsp;</span>
                            <mat-error
                              *ngIf="FamilyDeductible.errors?.['required']"
                            >
                              YearlyFamily Deductible is required</mat-error
                            >
                            <mat-error
                              *ngIf="FamilyDeductible.errors?.['invalid']"
                              >Yearly Family Deductible is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="FamilyDeductible.errors?.['nomatch']"
                              >Yearly Family >Deductible is invalid</mat-error
                            >
                            <mat-error
                              *ngIf="FamilyDeductible.errors?.['pattern']"
                              >Yearly Family Deductible is invalid</mat-error
                            >
                          </mat-form-field>
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >How frequent is the premium
                              paid/deducted?<ng-container
                                *ngIf="
                                  existingMember == 'Yes' && !frequencyRequired
                                "
                                >*</ng-container
                              >
                            </mat-label>
                            <select
                              matNativeControl
                              name="policyVO.frequency"
                              [(ngModel)]="formNv.referralPolicy.frequency"
                              #frequency="ngModel"
                              aria-label="Default select example"
                              [required]="frequencyRequired"
                            >
                              <ng-container
                                *ngIf="preference.dropDownValues != null"
                              >
                                <option
                                  *ngFor="
                                    let state of preference.dropDownValues[
                                      'FRQCD'
                                    ] | keyvalue : originalOrder
                                  "
                                  [value]="state.key"
                                >
                                  {{ state.value }}
                                </option>
                              </ng-container>
                            </select>
                            <mat-error *ngIf="frequency.errors?.['required']"
                              >Frequency is required</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Plan Tier<ng-container
                                *ngIf="
                                  existingMember == 'Yes' && !planTierRequired
                                "
                                >*</ng-container
                              ></mat-label
                            >
                            <select
                              matNativeControl
                              name="policyVO.planTier"
                              [(ngModel)]="formNv.referralPolicy.planTier"
                              aria-label="Default select example"
                              [required]="planTierRequired"
                              #planTier="ngModel"
                            >
                              <ng-container
                                *ngIf="preference.dropDownValues != null"
                              >
                                <option
                                  *ngFor="
                                    let state of preference.dropDownValues[
                                      'TIERCD'
                                    ] | keyvalue : originalOrder
                                  "
                                  [value]="state.key"
                                >
                                  {{ state.value }}
                                </option>
                              </ng-container>
                            </select>
                            <mat-error *ngIf="planTier.errors?.['required']"
                              >Plan Tier is required</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >How are premiums paid ?
                              <ng-container
                                *ngIf="
                                  existingMember == 'Yes' &&
                                  !premieumPaidOptionRequired
                                "
                                >*</ng-container
                              ></mat-label
                            >
                            <select
                              matNativeControl
                              name="policyVO.premiumPaidOption"
                              [(ngModel)]="
                                formNv.referralPolicy.premiumPaidOption
                              "
                              aria-label="Default select example"
                              [required]="premieumPaidOptionRequired"
                              #premieumPaidOption="ngModel"
                            >
                              <ng-container
                                *ngIf="preference.dropDownValues != null"
                              >
                                <option
                                  *ngFor="
                                    let state of preference.dropDownValues[
                                      'PREMPAIDCD'
                                    ] | keyvalue : originalOrder
                                  "
                                  [value]="state.key"
                                >
                                  {{ state.value }}
                                </option>
                              </ng-container>
                            </select>
                            <mat-error *ngIf="planTier.errors?.['required']"
                              >premieum Paid Option is required</mat-error
                            >
                          </mat-form-field>
                        </div>
                      </div>
                      <br />
                    </mat-card-content>
                  </mat-card>
                  <br />
                  <mat-card class="mat-elevation-z4">
                    <mat-card-header>
                      <mat-card-subtitle
                        ><label
                          ><strong>
                            Tell us about the health insurance coverage
                            available to you. (Select all that apply).
                          </strong>
                        </label>
                      </mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>
                      <br />
                      <div class="row">
                        <div class="col">
                          <section class="example-section" required>
                            <mat-slide-toggle
                              color="primary"
                              class="example-margin"
                              name="majorMedical"
                              [(ngModel)]="formNv.referralCoverage.majorMedical"
                              #MajorMedical="ngModel"
                            >
                              Major Medical (including hospital, outpatient,
                              physician, etc.)</mat-slide-toggle
                            >
                          </section>
                        </div>
                      </div>
                        <div class="row">
                        <div class="col">
                          <section class="example-section" required>
                            <mat-slide-toggle
                              color="primary"
                              class="example-margin"
                              name="hmo"
                              [(ngModel)]="formNv.referralCoverage.hmo"
                              #HMO="ngModel"
                            >
                              Health Maintanence Organization
                              (HMO)</mat-slide-toggle
                            >
                          </section>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <section class="example-section" required>
                            <mat-slide-toggle
                              color="primary"
                              class="example-margin"
                              name="dental"
                              [(ngModel)]="formNv.referralCoverage.dental"
                              #Dental="ngModel"
                            >
                              Dental
                            </mat-slide-toggle>
                          </section>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <section class="example-section" required>
                            <mat-slide-toggle
                              color="primary"
                              class="example-margin"
                              name="vision"
                              [(ngModel)]="formNv.referralCoverage.vision"
                              #Vision="ngModel"
                            >
                              Vision
                            </mat-slide-toggle>
                          </section>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <section class="example-section" required>
                            <mat-slide-toggle
                              color="primary"
                              class="example-margin"
                              name="medicare"
                              [(ngModel)]="formNv.referralCoverage.medicare"
                              #Medicare="ngModel"
                            >
                              Medicare</mat-slide-toggle
                            >
                          </section>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <section class="example-section" required>
                            <mat-slide-toggle
                              color="primary"
                              class="example-margin"
                              name="prescriptionDrugs"
                              [(ngModel)]="
                                formNv.referralCoverage.prescriptionDrugs
                              "
                              #PrescriptionDrugs="ngModel"
                            >
                              Prescription Drugs</mat-slide-toggle
                            >
                          </section>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                  <br />
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button
                      mat-raised-button
                      matStepperPrevious
                      style="background-color: #b89d18; color: white"
                      (click)="goBack()"
                    >
                      Previous
                    </button>
                    <button
                      mat-raised-button
                      color="primary"
                      matStepperNext
                      (click)="goForward()"
                    >
                      Next
                    </button>
                  </div>
                </fieldset>
              </mat-step>
              <mat-step
                label="Family Members"
                aria-label="Family Members"
                [completed]="familyMemberCheck()"
              >
                <fieldset
                  class="shadow p-5 mb-1 rounded-5"
                  style="border: 2px solid #63b1bc"
                >
                  <legend
                    class="float-none w-auto p-1 mx-5 fw-bold fs-1"
                    style="color: #003057"
                  >
                    Apply Now
                  </legend>

                  <div class="row">
                    <div class="col">
                      <mat-label class="fw-bold"
                        >Are there other family member(s) covered by your insurance, including Medicaid recipients and anyone that may be added to this policy? <span class="text-danger">*</span>
                      </mat-label>
                      <mat-radio-group
                        #group
                        aria-label="Select an option"
                        [(ngModel)]="isFamilyMemberMedicate"
                        [required]="isFamilyRequired"
                        #familyMedicate="ngModel"
                        name="isFamilyMemberMedicate"
                        (change)="removeSavedFamilyMembers($event)"
                      >
                        <mat-radio-button
                          value="Yes"
                          [required]="isFamilyRequired"
                        >
                          Yes
                        </mat-radio-button>
                        <mat-radio-button
                          value="No"
                          [required]="isFamilyRequired"
                        >
                          No
                        </mat-radio-button>
                      </mat-radio-group>
                      <mat-error *ngIf="familyMedicate.errors?.['required']"
                        >Your response is required</mat-error
                      >
                    </div>
                  </div>
                  <br />

                  <div *ngIf="isFamilyMemberMedicate == 'Yes'">
                    <br />
                    <mat-card class="mat-elevation-z4">
                      <mat-card-header>
                        <mat-card-subtitle
                          ><label
                            ><strong> Add Family Members </strong>
                          </label></mat-card-subtitle
                        >
                      </mat-card-header>
                      <mat-card-content>
                        <br />
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >First Name<ng-container
                                  *ngIf="!otherFnRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input
                                matInput
                                type="text"
                                name="otherfirstNm"
                                [(ngModel)]="otherfirstNm"
                                maxlength="20"
                                pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                                #otherFN="ngModel"
                                [required]="otherFnRequired"
                                uppercase
                                (keypress)="allowAlphabets2($event, otherFN)"
                              />
                              <mat-error *ngIf="otherFN.errors?.['required']"
                                >First Name is required</mat-error
                              >
                              <mat-error *ngIf="otherFN.errors?.['invalid']"
                                >First Name is invalid</mat-error
                              >
                              <mat-error *ngIf="otherFN.errors?.['pattern']"
                                >First Name is invalid</mat-error
                              >
                              <mat-error *ngIf="otherFN.errors?.['nomatch']"
                                >Only Alphabetical, Space, Hyphen, and
                                Apostrophe are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label>MI</mat-label>
                              <input
                                matInput
                                type="text"
                                name="othermiNm"
                                [(ngModel)]="othermiNm"
                                maxlength="1"
                                #otherMi="ngModel"
                                uppercase
                                (keypress)="
                                  allowOnlyOneAlphabet($event, otherMi)
                                "
                              />
                              <mat-error *ngIf="otherMi.errors?.['invalid']"
                                >Middle Name is invalid</mat-error
                              >
                              <mat-error *ngIf="otherMi.errors?.['nomatch']"
                                >Only Alphabet is allowed</mat-error
                              >
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Last Name<ng-container *ngIf="!otherLnRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input
                                matInput
                                type="text"
                                name="otherlastNm"
                                [(ngModel)]="otherlastNm"
                                maxlength="20"
                                #otherLN="ngModel"
                                [required]="otherLnRequired"
                                pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                                uppercase
                                (keypress)="allowAlphabets2($event, otherLN)"
                              />
                              <mat-error *ngIf="otherLN.errors?.['required']"
                                >Last Name is required</mat-error
                              >
                              <mat-error *ngIf="otherLN.errors?.['invalid']"
                                >Last Name is invalid</mat-error
                              >
                              <mat-error *ngIf="otherLN.errors?.['pattern']"
                                >Last Name is invalid</mat-error
                              >
                              <mat-error *ngIf="otherLN.errors?.['nomatch']"
                                >Only Alphabetical, Space, Hyphen, and
                                Apostrophe are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>

                        </div>
                        <br />
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Social Security Number<ng-container
                                  *ngIf="!otherSsnRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input
                                matInput
                                type="text"
                                name="otherssnNum"
                                [(ngModel)]="otherssnNum"
                                (input)="
                                  otherssnNum = ssnmask($event, otherSsn)
                                "
                                maxlength="11"
                                (keypress)="isNumeric($event, otherSsn)"
                                #otherSsn="ngModel"
                                (blur)="verifySSN($event, true)"
                                pattern="^\d{3}-\d{2}-\d{4}$"
                                [required]="otherSsnRequired"
                              />
                              <mat-error *ngIf="otherSsn.errors?.['required']"
                                >Social Security Number is required</mat-error
                              >
                              <mat-error *ngIf="otherSsn.errors?.['invalid']"
                                >Social Security Number is invalid</mat-error
                              >
                              <mat-error *ngIf="otherSsn.errors?.['invalidSsn']"
                                >Social Security Number is invalid</mat-error
                              >
                              <mat-error *ngIf="otherSsn.errors?.['pattern']">
                                <ng-container *ngIf="otherssnNum.length < 11"
                                  >Social Security Number length is
                                  short</ng-container
                                >
                                <ng-container *ngIf="otherssnNum.length > 10"
                                  >Social Security Number is
                                  invalid</ng-container
                                >
                              </mat-error>
                              <mat-error *ngIf="otherSsn.errors?.['duplicate']"
                                >SSN already used.</mat-error
                              >
                              <mat-error
                                *ngIf="otherSsn.errors?.['recordPresent']"
                                >{{ getSSNUsedMessage() }}</mat-error
                              >
                              <mat-error *ngIf="otherSsn.errors?.['nomatch']"
                                >Only numerical values are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Date of Birth<ng-container
                                  *ngIf="!otherDobRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <input
                                matInput
                                [matDatepicker]="picker4"
                                [min]="prev100year"
                                [max]="today"
                                name="d6"
                                [(ngModel)]="otherdobDate"
                                [required]="otherDobRequired"
                                #otherDob="ngModel"
                                minlength="8"
                                maxlength="10"
                                placeholder="MMDDYYYY"
                                (input)="datemask2($event, otherDob)"
                                (keypress)="onlyNumeric($event, otherDob)"
                                (blur)="parseDate($event, otherDob)"
                              />

                              <mat-datepicker-toggle
                                matIconSuffix
                                [for]="picker4"
                              ></mat-datepicker-toggle>
                              <mat-datepicker #picker4></mat-datepicker>
                              <mat-error *ngIf="otherDob.errors?.['required']"
                                >Date of Birth is required</mat-error
                              >
                              <mat-error *ngIf="otherDob.errors?.['invalid']"
                                >Date of Birth is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="otherDob.errors?.['matDatepickerMin']"
                                >Date of Birth is out of range</mat-error
                              >
                              <mat-error
                                *ngIf="otherDob.errors?.['matDatepickerMax']"
                                >Date of Birth is out of range</mat-error
                              >
                              <mat-error *ngIf="otherDob.errors?.['nomatch']"
                                >Only numerical values are allowed</mat-error
                              >
                              <mat-error
                                *ngIf="otherDob.errors?.['invalidDate'] || otherDob.errors?.['matDatepickerParse']"
                                >Date of Birth is invalid</mat-error
                              >
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Gender<ng-container *ngIf="!otherGnRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <select
                                matNativeControl
                                name="othergenderRf"
                                [(ngModel)]="othergenderRf"
                                #otherGender="ngModel"
                                aria-label="Default select example"
                                [required]="otherGnRequired"
                              >
                                <ng-container
                                  *ngIf="preference.dropDownValues != null"
                                >
                                  <option
                                    *ngFor="
                                      let g of preference.dropDownValues[
                                        'GENCD'
                                      ] | keyvalue : originalOrder
                                    "
                                    [value]="g.key"
                                  >
                                    {{ g.value }}
                                  </option>
                                </ng-container>
                              </select>
                              <mat-error
                                *ngIf="otherGender.errors?.['required']"
                                >Gender is required</mat-error
                              >
                            </mat-form-field>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Relationship to Policyholder<ng-container
                                  *ngIf="!otherRsRequired"
                                  >*</ng-container
                                ></mat-label
                              >
                              <select
                                matNativeControl
                                name="otherrelationshipRf"
                                aria-label="Default select example"
                                [(ngModel)]="otherrelationshipRf"
                                #otherRelationship="ngModel"
                                [required]="otherRsRequired"
                              >
                                <ng-container
                                  *ngIf="preference.dropDownValues != null"
                                >
                                  <option
                                    *ngFor="
                                      let r of preference.dropDownValues[
                                        'RSHCD'
                                      ] | keyvalue : originalOrder
                                    "
                                    [value]="r.key"
                                  >
                                    {{ r.value }}
                                  </option>
                                </ng-container>
                              </select>
                              <mat-error
                                *ngIf="otherRelationship.errors?.['required']"
                                >Relationship is required</mat-error
                              >
                            </mat-form-field>
                          </div>
                          <div class="col">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Catastrophic Health Condition</mat-label
                              >
                              <input
                                matInput
                                type="text"
                                name="CatastrophicHealthCondition"
                                uppercase
                                [(ngModel)]="healthCondition"
                                maxlength="100"
                                #catastrophicHC="ngModel"
                                pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                                (keypress)="
                                  allowAlphabets2($event, catastrophicHC)
                                "
                              />
                              <mat-error
                                *ngIf="catastrophicHC.errors?.['invalid']"
                                >Catastrophic Health Condition is
                                invalid</mat-error
                              >
                              <mat-error
                                *ngIf="catastrophicHC.errors?.['pattern']"
                                >Catastrophic Health Condition is
                                invalid</mat-error
                              >
                              <mat-error
                                *ngIf="catastrophicHC.errors?.['nomatch']"
                                >Only Alphabetical, Space, Hyphen, and
                                Apostrophe are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col">
                            <mat-label
                              >Is this person a Medicaid recipient?
                              <span class="text-danger">*</span></mat-label
                            >

                            <mat-radio-group
                              #group
                              color="primary"
                              aria-label="Select an option"
                              [(ngModel)]="isOtherMedicaid"
                              [required]="isOtherMedicateRequired"
                              name="isOtherMedicaid"
                              (change)="isMedicaidOther()"
                              #isOtherMedicate="ngModel"
                            >
                              <mat-radio-button value="Yes">
                                Yes
                              </mat-radio-button>
                              <mat-radio-button value="No">
                                No
                              </mat-radio-button>
                            </mat-radio-group>
                            <mat-error
                              *ngIf="isOtherMedicate.errors?.['required'] && customerForm.submitted"
                              >Your response is required</mat-error
                            >
                          </div>
                          <div class="col" *ngIf="isOtherMedicaid == 'Yes'">
                            <mat-form-field appearance="outline">
                              <mat-label
                                >Medicaid ID<ng-container
                                  *ngIf="!otherMaNumRequired"
                                  >*</ng-container
                                >
                              </mat-label>
                              <input
                                matInput
                                type="text"
                                name="othermaNum"
                                [(ngModel)]="othermaNum"
                                uppercase
                                maxlength="11"
                                pattern="^\d{11}$"
                                [required]="otherMaNumRequired"
                                #otherVOmaNum="ngModel"
                                (keypress)="isNumeric($event, otherVOmaNum)"
                                (blur)="isMedicaidValid($event, otherVOmaNum)"
                              />
                              <mat-error
                                *ngIf="otherVOmaNum.errors?.['required']"
                                >Medicaid ID is required</mat-error
                              >
                              <mat-error
                                *ngIf="otherVOmaNum.errors?.['pattern']"
                                >Medicaid ID is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="otherVOmaNum.errors?.['invalid']"
                                >Medicaid ID is invalid</mat-error
                              >
                              <mat-error
                                *ngIf="otherVOmaNum.errors?.['nomatch']"
                                >Only numerical values are allowed</mat-error
                              >
                            </mat-form-field>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col">
                            <mat-label
                              >Is this person enrolled in the health insurance
                              plan listed in previous page?
                              <span class="text-danger">*</span>
                            </mat-label>

                            <mat-radio-group
                              #group
                              aria-label="Select an option"
                              [(ngModel)]="otherEnrolled"
                              name="otherEnrolled"
                              #otherEnrolledResp="ngModel"
                              [required]="otherEnrolledRequired"
                            >
                              <mat-radio-button value="Yes">
                                Yes
                              </mat-radio-button>
                              <mat-radio-button value="No">
                                No
                              </mat-radio-button>
                              <mat-error
                                *ngIf="otherEnrolledResp.errors?.['required']"
                                >Your Response is Required</mat-error
                              >
                            </mat-radio-group>
                          </div>
                          <mat-error *ngIf="addClearFamilyFilled"
                            >Do you want to add or clear the filled family
                            member details before clicking on the Next
                            button?</mat-error
                          >
                        </div>
                        <div class="row">
                          <div class="col text-center">
                            <button
                              id="addFamilyMember"
                              mat-raised-button
                              color="primary"
                              type="button"
                              [disabled]="addFamilyMemberButton"
                              class="m-1"
                              (click)="addFamilyMember($event)"
                            >
                              <ng-container *ngIf="editIndex == undefined"
                                >Add Family Member</ng-container
                              >
                              <ng-container *ngIf="editIndex != undefined"
                                >Save Family Member</ng-container
                              >
                            </button>
                            <button
                              id="clearFamilyMember"
                              mat-raised-button
                              type="button"
                              class="m-1"
                              (click)="clear($event)"
                            >
                              Clear Family Member
                            </button>
                          </div>
                        </div>
                        <br />
                      </mat-card-content>
                    </mat-card>
                    <br />
                    <div *ngIf="formNv.referralMemberList.length > 0">
                      <div class="text-center fw-bold">
                        Below are the family members you have already added
                      </div>
                      <br />

                      <table
                        mat-table
                        class="table table-bordered table-hover mat-elevation-z8"
                        style="border: 2px solid #63b1bc"
                      >
                        <thead class="table-success">
                          <tr>
                            <th scope="col">First Name</th>
                            <th scope="col">MI</th>
                            <th scope="col">Last Name</th>
                            <th scope="col">Medicaid ID</th>
                            <th scope="col">Social Security Number</th>
                            <th scope="col">Date of Birth</th>
                            <th scope="col">Gender</th>
                            <th scope="col">Relationship</th>
                            <th scope="col">Health Condition</th>
                            <th scope="col"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            *ngFor="
                              let p of formNv.referralMemberList;
                              let i = index
                            "
                          >
                            <td>{{ p.firstNm }}</td>
                            <td>{{ p.miNm }}</td>
                            <td>{{ p.lastNm }}</td>
                            <td>{{ p.maNum }}</td>
                            <td>{{ p.ssnNum }}</td>
                            <td>{{ p.dobDt }}</td>
                            <td>
                              <ng-container *ngIf="p.gender == 'F'"
                                >Female</ng-container
                              >
                              <ng-container *ngIf="p.gender == 'M'"
                                >Male</ng-container
                              >
                            </td>
                            <td>{{ p.relationship }}</td>
                            <td>{{ p.healthCondition }}</td>
                            <td>
                              <button
                                mat-mini-fab
                                color="warn"
                                id="removeMember"
                                (click)="removeMember(i)"
                              >
                                <span class="bi bi-trash"></span>
                              </button>
                              <button
                                mat-mini-fab
                                color="primary"
                                id="editMember"
                                (click)="editMember(i)"
                              >
                                <span class="bi bi-pencil-square"></span>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="row" *ngIf="this.isFamilyMemberMedicate == 'Yes'">
                    <mat-error *ngIf="additionalMembersReq">
                      At least one family member should be added.
                    </mat-error>
                    <mat-error *ngIf="additionalMaxReached">
                      Family member limit has reached to 50.
                    </mat-error>
                  </div>
                  <ng-container
                    *ngIf="
                      isFamilyMemberMedicate == 'No' && isMemberMedicaid == 'No'
                    "
                  >
                    <mat-card>
                      <mat-card-content>
                        <div class="alert alert-danger d-flex" role="alert">
                          <i class="bi bi-exclamation-triangle-fill px-2"></i>

                          Nevada HIPP applicants must be active Medicaid
                          clients. Based on your responses, you do not qualify
                          for HIPP.
                        </div>
                      </mat-card-content>
                    </mat-card>
                  </ng-container>
                  <br />
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button
                      mat-raised-button
                      color="warn"
                      matStepperPrevious
                      style="background-color: #b89d18; color: white"
                      (click)="goBack2()"
                    >
                      Previous
                    </button>
                    <ng-container
                      *ngIf="
                        !(
                          this.isFamilyMemberMedicate == 'No' &&
                          this.isMemberMedicaid == 'No'
                        )
                      "
                    >
                      <button
                        mat-raised-button
                        color="primary"
                        matStepperNext
                        (click)="goForward2()"
                      >
                        Next
                      </button>
                    </ng-container>
                  </div>
                </fieldset>
              </mat-step>
              <mat-step
                label="Required Documents"
                aria-label="Required Documents"
                [completed]="rightsResponsibilityCheck()"
              >
                <fieldset
                  class="shadow p-5 mb-1 rounded-5"
                  style="border: 2px solid #63b1bc"
                >
                  <legend
                    class="float-none w-auto p-1 mx-5 fw-bold fs-1"
                    style="color: #003057"
                  >
                    NV HIPP Required Documents
                  </legend>
                  <h4>
                  <strong
                    >After submitting your online application, you must send the
                    following documents to the HIPP team:</strong
                  ></h4>
                  <div class="container-fluid">
                    <ul>
                      ➢ Copy of the four (4) most recent paystubs.
                      <br />
                      ➢ Copy of the front and back of commercial (Employer)
                      health insurance card.<br />
                      ➢ Copy of the front and back of Medicaid card.<br />
                      ➢ Copy of Explanation of benefits (EOB)/ Medical bills for
                      the last twelve (12) months for enrollee.<br />
                      <br />
                    </ul>
                    <h4>
                    <strong
                      >You can send those documents to us in one of the
                      following ways:
                    </strong></h4>
                    <div class="container-fluid fw-bold">
                      <ul>
                        ➢ Email:
                        <a
                          target="_blank"
                          [href]="emailTo"
                          alt="email"
                          >{{ email }}</a
                        >
                        <br />
                        ➢ Fax:
                        {{
                          faxNo
                        }}
                        <br />
                        ➢ Mail to:
                        {{
                          address
                        }}
                      </ul>
                    </div>
                  </div>
                  <br />

                  <section class="example-section" required>
                    <mat-slide-toggle
                      color="primary"
                      class="example-margin"
                      name="signReadCheck"
                      [(ngModel)]="signReadCheck"
                      #signReadChecked="ngModel"
                      [required]="signCheckRequired"
                      ><span class="text-danger">*</span> Please slide this
                      toggle button to confirm you understand where to send the
                      required documents.</mat-slide-toggle
                    >
                  </section>
                  <mat-error
                    *ngIf="signReadChecked.errors?.['required'] && customerForm.submitted"
                    >Your response is required</mat-error
                  >

                  <br />
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button
                      mat-raised-button
                      color="warn"
                      matStepperPrevious
                      (click)="clear($event)"
                      style="background-color: #b89d18; color: white"
                    >
                      Previous
                    </button>
                    <button
                      mat-raised-button
                      color="primary"
                      matStepperNext
                      (click)="goForward3()"
                    >
                      Next
                    </button>
                  </div>
                </fieldset>
              </mat-step>
              <mat-step
                label=" HIPAA Release Authority"
                aria-label="HIPAA Release Authority"
                [completed]="voterRegistrationCheck()"
              >
                <fieldset
                  class="shadow p-5 mb-1 rounded-5"
                  style="border: 2px solid #63b1bc"
                >
                  <legend
                    class="float-none w-auto p-1 mx-5 fw-bold fs-1"
                    style="color: #003057"
                  >
                    HIPAA Release Authority
                  </legend>

                  <div class="container-fluid" style="text-align: center">
                    <H3>
                      <b>HIPPA Release Authority </b>
                    </H3>
                    <h4>
                      &nbsp;
                      <b
                        >AUHTORIZATION FOR THE USE AND DISCLOUSER OF <br />THE
                        PROTECTED HEALTH INFORMATION</b
                      >
                    </h4>

                    <div class="row" style="padding-left: 50; padding-bottom: 100;">
                      <div class="col"></div>
                      <div class="col">
                        <mat-form-field appearance="outline">
                          <mat-label
                            >Recipient's First Name<ng-container
                              *ngIf="!recipientfirstNmRequired"
                              >*</ng-container
                            ></mat-label
                          >
                          <input
                            matInput
                            type="text"
                            name="hipaaRecipientFirstNm"
                            [(ngModel)]="
                              formNv.referralCase.hipaaRecipientFirstNm
                            "
                            maxlength="20"
                            #hipaaRecipientFirstNm="ngModel"
                            [required]="recipientfirstNmRequired"
                            uppercase
                            pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                            (keypress)="
                              allowAlphabets2($event, hipaaRecipientFirstNm)
                            "
                          />
                          <mat-error
                            *ngIf="hipaaRecipientFirstNm.errors?.['required']"
                            >Recipient's First Name is required</mat-error
                          >
                          <mat-error
                            *ngIf="hipaaRecipientFirstNm.errors?.['invalid']"
                            >Recipient's First Name is invalid</mat-error
                          >
                          <mat-error
                            *ngIf="hipaaRecipientFirstNm.errors?.['pattern']"
                            >Recipient's First Name is invalid</mat-error
                          >
                          <mat-error
                            *ngIf="hipaaRecipientFirstNm.errors?.['nomatch']"
                            >Only Alphabetical, Space, Hyphen, and Apostrophe
                            are allowed</mat-error
                          >
                        </mat-form-field>
                      </div>
                      <div class="col">
                        <mat-form-field appearance="outline">
                          <mat-label
                            >Recipient's Last Name<ng-container
                              *ngIf="!recipientLastNmRequired"
                              >*</ng-container
                            ></mat-label
                          >
                          <input
                            matInput
                            type="text"
                            name="hipaaRecipientLastNm"
                            [(ngModel)]="
                              formNv.referralCase.hipaaRecipientLastNm
                            "
                            maxlength="20"
                            #hipaaRecipientLastNm="ngModel"
                            [required]="recipientLastNmRequired"
                            uppercase
                            pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                            (keypress)="
                              allowAlphabets2($event, hipaaRecipientLastNm)
                            "
                          />
                          <mat-error
                            *ngIf="hipaaRecipientLastNm.errors?.['required']"
                            >Recipient's Last Name is required</mat-error
                          >
                          <mat-error
                            *ngIf="hipaaRecipientLastNm.errors?.['invalid']"
                            >Recipient's Last Name is invalid</mat-error
                          >
                          <mat-error
                            *ngIf="hipaaRecipientLastNm.errors?.['pattern']"
                            >Recipient's Last Name is invalid</mat-error
                          >
                          <mat-error
                            *ngIf="hipaaRecipientLastNm.errors?.['nomatch']"
                            >Only Alphabetical, Space, Hyphen, and Apostrophe
                            are allowed</mat-error
                          >
                        </mat-form-field>
                      </div>
                      <div class="col"></div>
                    </div>
                    <br>
                    <div class="row">
                      <div class="col"></div>
                      <div class="col">
                        <mat-form-field appearance="outline">
                          <mat-label
                            >Medicaid ID Number<ng-container
                              *ngIf="!isMedicaidReq"
                              >*</ng-container
                            ></mat-label
                          >
                          <input
                            matInput
                            type="text"
                            name="hipaaMedicaIdNum"
                            [(ngModel)]="formNv.referralCase.hipaaMedicaidNum"
                            uppercase
                            maxlength="11"
                            pattern="^\d{11}$"
                            #hipaaMedicaIdNum="ngModel"
                            (keypress)="isNumeric($event, hipaaMedicaIdNum)"
                            [required]="isMedicaidReq"
                            (blur)="isMedicaidValid($event, hipaaMedicaIdNum)"
                          />
                          <mat-error
                            *ngIf="hipaaMedicaIdNum.errors?.['required']"
                            >Medicaid ID Number is required</mat-error
                          >
                          <mat-error
                            *ngIf="hipaaMedicaIdNum.errors?.['pattern']"
                            >Medicaid ID Number is invalid</mat-error
                          >
                          <mat-error
                            *ngIf="hipaaMedicaIdNum.errors?.['invalid']"
                            >Medicaid ID Number is invalid</mat-error
                          >
                          <mat-error
                            *ngIf="hipaaMedicaIdNum.errors?.['nomatch']"
                            >Only numerical values are allowed</mat-error
                          >
                        </mat-form-field>
                      </div>
                      <div class="col">
                        <mat-form-field appearance="outline">
                          <mat-label
                            >HIPP Effective Date<ng-container
                              *ngIf="!hippEffectiveDateReq"
                              >*</ng-container
                            ></mat-label
                          >
                          <input
                            matInput
                            [min]="prev100year"
                            [max]="today"
                            [matDatepicker]="picker"
                            name="hippEffectiveDate"
                            #hippEffectiveDate="ngModel"
                            [(ngModel)]="hippeffectivedate"
                            [required]="hippEffectiveDateReq"
                            minlength="8"
                            maxlength="10"
                            placeholder="MMDDYYYY"
                            (input)="datemask2($event, hippEffectiveDate)"
                            (keypress)="onlyNumeric($event, hippEffectiveDate)"
                            (blur)="parseDate($event, hippEffectiveDate)"
                          />

                          <mat-datepicker-toggle
                            matIconSuffix
                            [for]="picker"
                          ></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                          <mat-error
                            *ngIf="hippEffectiveDate.errors?.['required']"
                            >HIPP Effective Date is required</mat-error
                          >
                          <mat-error
                            *ngIf="hippEffectiveDate.errors?.['invalid']"
                            >HIPP Effective Date is invalid</mat-error
                          >
                          <mat-error
                            *ngIf="hippEffectiveDate.errors?.['matDatepickerMin']"
                            >HIPP Effective Date is out of range</mat-error
                          >
                          <mat-error
                            *ngIf="hippEffectiveDate.errors?.['matDatepickerMax']"
                            >HIPP Effective Date is out of range</mat-error
                          >
                          <mat-error
                            *ngIf="hippEffectiveDate.errors?.['nomatch']"
                            >Only numerical values are allowed</mat-error
                          >
                          <mat-error
                            *ngIf="hippEffectiveDate.errors?.['invalidDate']"
                            >HIPP Effective Date is invalid</mat-error
                          >
                        </mat-form-field>
                        <br>
                        <br>
                      </div>
                      <div class="col"></div>
                      <br>
                    </div>
                    <p>
                      [The Release Authority Applies to Any Information Governed
                      by the Health Insurance Portability and Accountability Act
                      of 1996 "HIPPA"]
                    </p>
                    <div
                      style="
                        border-style: solid;
                        text-align: left;
                        padding-block: 10px;
                        padding-left: 10px;
                        padding-right: 10px;
                      "
                    >
                      <ol>
                        <li>
                          I hereby authorize my employer’s health insurance
                          carrier or my employer’s benefits representative to
                          release or disclose my Protected Health Information
                          (PHI) as described below. I understand that the
                          information may be re-disclosed and no longer
                          protected by federal privacy regulations.
                        </li>
                        <li>
                          Information obtained will be used for the following
                          purpose(s): Prequalification for enrollment in the
                          Health Insurance Premium Payment (HIPP) program, and
                          re-evaluation for continued enrollment. HIPP is
                          administered by Health Management Systems (HMS) on
                          behalf of the State of Nevada, Division of Health Care
                          Financing and Policy (DHCFP). Prequalification
                          requires contact with your insurance carrier or your
                          employer’s benefits representative to verify insurance
                          information such as policy number, coverage, premiums
                          and co-payments.
                        </li>
                        <li>
                          Persons or entities authorized to receive and use the
                          information include the DHCFP and its Fiscal Agent,
                          DXC Technology and HMS. This HIPAA Authorization form
                          is in effect until I am no longer receiving services
                          from Medicaid.
                        </li>
                        <li>
                          No person and/or entity authorized to use/disclose the
                          information will receive compensation for doing so.
                        </li>
                        <li>
                          I understand that this authorization is voluntary and
                          that I may refuse to sign this authorization. My
                          refusal to sign will not affect my payment for or
                          coverage of services, or ability to obtain treatment;
                          however, it may or may not affect my eligibility for
                          future services as specified under number (6) of this
                          form.
                        </li>
                        <li>
                          The purpose of this authorization is for the DHCFP to
                          determine HIPP eligibility before enrollment; the
                          requested use or disclosure is not for psychotherapy
                          notes. If I refuse to sign this authorization, the
                          DHCFP reserves the right to deny enrollment or
                          eligibility for benefits.
                        </li>
                        <li>
                          I understand that I may revoke this authorization at
                          any time by notifying the DHCFP in writing, except to
                          the extent that:
                          <ol class="parenthesis">
                            <li>
                              Action has already been taken as a result of this
                              authorization; or
                            </li>
                            <li>
                              If this authorization is obtained as a condition
                              of obtaining insurance coverage, other law
                              provides the insurer with the right to contest a
                              claim under the policy or the policy itself.
                            </li>
                          </ol>
                        </li>
                        <li>
                          I understand that I may inspect or copy the
                          information used or disclosed.
                        </li>
                        <li>
                          I understand that I have a right to request and
                          receive a Notice of Privacy Practices from DHCFP.
                        </li>
                      </ol>
                    </div>
                    <br />
                    <p style="text-align: left">
                      By typing your name below, you are signing this
                      application electronically.
                    </p>
                    <div class="row" style="padding-left: 50">
                      <div class="col">
                        <mat-form-field appearance="outline">
                          <mat-label
                            >First Name<ng-container
                              *ngIf="!submitterFirstNmRequired"
                              >*</ng-container
                            ></mat-label
                          >
                          <input
                            matInput
                            type="text"
                            name="hipaaSubmitterFirstName"
                            [(ngModel)]="
                              formNv.referralCase.hipaaSubmitterFirstName
                            "
                            maxlength="20"
                            #hipaaSubmitterFirstName="ngModel"
                            [required]="submitterFirstNmRequired"
                            uppercase
                            pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                            (keypress)="
                              allowAlphabets2($event, hipaaSubmitterFirstName)
                            "
                          />
                          <mat-error
                            *ngIf="hipaaSubmitterFirstName.errors?.['required']"
                            >First Name is required</mat-error
                          >
                          <mat-error
                            *ngIf="hipaaSubmitterFirstName.errors?.['invalid']"
                            >First Name is invalid</mat-error
                          >
                          <mat-error
                            *ngIf="hipaaSubmitterFirstName.errors?.['pattern']"
                            >First Name is invalid</mat-error
                          >
                          <mat-error
                            *ngIf="hipaaSubmitterFirstName.errors?.['nomatch']"
                            >Only Alphabetical, Space, Hyphen, and Apostrophe
                            are allowed</mat-error
                          >
                        </mat-form-field>
                      </div>
                      <div class="col">
                        <mat-form-field appearance="outline">
                          <mat-label
                            >Last Name<ng-container
                              *ngIf="!submitterLastNmRequired"
                              >*</ng-container
                            ></mat-label
                          >
                          <input
                            matInput
                            type="text"
                            name="hipaaSubmitterLastName"
                            [(ngModel)]="
                              formNv.referralCase.hipaaSubmitterLastName
                            "
                            maxlength="20"
                            #hipaaSubmitterLastName="ngModel"
                            [required]="submitterLastNmRequired"
                            uppercase
                            pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                            (keypress)="
                              allowAlphabets2($event, hipaaSubmitterLastName)
                            "
                          />
                          <mat-error
                            *ngIf="hipaaSubmitterLastName.errors?.['required']"
                            >Last Name is required</mat-error
                          >
                          <mat-error
                            *ngIf="hipaaSubmitterLastName.errors?.['invalid']"
                            >Last Name is invalid</mat-error
                          >
                          <mat-error
                            *ngIf="hipaaSubmitterLastName.errors?.['pattern']"
                            >Last Name is invalid</mat-error
                          >
                          <mat-error
                            *ngIf="hipaaSubmitterLastName.errors?.['nomatch']"
                            >Only Alphabetical, Space, Hyphen, and Apostrophe
                            are allowed</mat-error
                          >
                        </mat-form-field>
                      </div>

                      <div class="col">
                        <mat-form-field appearance="outline">
                          <mat-label>Date</mat-label>
                          <input
                            matInput
                            name="hippEffectiveDate1"
                            [(ngModel)]="hippeffectivedate1"
                            readonly
                          />
                        </mat-form-field>
                      </div>
                    </div>
                    <br>
                    <p>
                      <i
                        >The HIPP program is administered by HMS, under contract
                        with the Department of Health and Human Services,<br />
                        Division of Health Care Financiing and Policy.</i
                      >
                    </p>
                  </div>
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button
                      mat-raised-button
                      color="warn"
                      matStepperPrevious
                      style="background-color: #b89d18; color: white"
                    >
                      Previous
                    </button>
                    <button
                      mat-raised-button
                      color="primary"
                      matStepperNext
                      (click)="goForward4()"
                    >
                      Next
                    </button>
                  </div>
                </fieldset>

                <br />
              </mat-step>
              <mat-step label="Submit" aria-label="Submit" [completed]="submitCheck()">
                <fieldset
                  class="shadow p-5 mb-1 rounded-5"
                  style="border: 2px solid #63b1bc"
                >
                  <legend
                    class="float-none w-auto p-1 mx-5 fw-bold fs-1"
                    style="color: #003057"
                  >
                    Electronic Signature Agreement
                  </legend>
                  <div class="container-fluid">
                    <br />
                    <div>
                      <h4><strong>ELECTRONIC SIGNATURE</strong></h4>
                      <br />
                      <p>
                        I certify under penalty of perjury that the information
                        I have given on this application is true, complete, and
                        correct to the best of my knowledge, including the
                        information I have given regarding the U.S. citizenship
                        or immigration status of all household members. I
                        understand that I and any adult household member will be
                        subject to disqualification and prosecution and will be
                        required to repay ineligible benefits or services if we
                        knowingly give false, incorrect, or incomplete
                        information in order to obtain or try to obtain health
                        care assistance. By signing this application, I give
                        permission for the release of information to the Nevada
                        Department of Health by any persons or agencies who have
                        knowledge of my circumstances.
                      </p>
                    </div>
                    <br />
                    <section class="example-section" required>
                      <mat-slide-toggle
                        color="primary"
                        class="example-margin"
                        name="signElectronicSignatureChecked"
                        #signElectronicCheck="ngModel"
                        [(ngModel)]="signElectronicSignatureChecked"
                        [required]="signElectronicRequired"
                        ><span class="text-danger">*</span> Please slide this
                        toggle button to let us know that you have read the
                        “Electronic Signature Agreement”.</mat-slide-toggle
                      >
                    </section>
                    <mat-error
                      *ngIf="signElectronicCheck.errors?.['required'] && customerForm.submitted"
                      >Your response is required</mat-error
                    >

                    <br />
                    <br />
                    <div class="container">
                      <mat-card class="mat-elevation-z4">
                        <mat-card-header>
                          <div class="row">
                            <div class="col">
                              <mat-label
                                ><span class="text-danger">*</span> Please
                                select the correct description of the person
                                signing this application:</mat-label
                              >
                            </div>
                          </div>
                        </mat-card-header>
                        <mat-card-content>
                          <div class="row">
                            <div class="col">
                              <mat-radio-group
                                #group
                                class="example-radio-group"
                                [(ngModel)]="signApplicant"
                                [required]="signApplicantRequired"
                                name="signApplicant"
                                #signApplicat="ngModel"
                                (click)="signApplicantCheck()"
                              >
                                <mat-radio-button
                                  #buttons
                                  class="example-radio-button"
                                  value="self"
                                  [required]="signApplicantRequired"
                                >
                                  I am the applicant signing for myself
                                </mat-radio-button>
                                <mat-radio-button
                                  #buttons
                                  class="example-radio-button"
                                  value="onbehalf"
                                  [required]="signApplicantRequired"
                                >
                                  I am signing on the applicant’s behalf
                                </mat-radio-button>
                              </mat-radio-group>
                              <mat-error
                                *ngIf="signApplicat.errors?.['required'] && customerForm.submitted"
                                >Your response is required</mat-error
                              >
                            </div>
                            <div class="col"></div>
                            <div class="col"></div>
                          </div>
                          <br />

                          <div class="row">
                            <div class="col">
                              <mat-form-field appearance="outline">
                                <mat-label
                                  >First Name<ng-container
                                    *ngIf="!signfirstNmRequired"
                                    >*</ng-container
                                  ></mat-label
                                >
                                <input
                                  matInput
                                  type="text"
                                  name="signfirstNm"
                                  [(ngModel)]="
                                    formNv.referralCase.submitterFirstName
                                  "
                                  maxlength="20"
                                  #signFN="ngModel"
                                  [required]="signfirstNmRequired"
                                  uppercase
                                  pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                                  (keypress)="allowAlphabets2($event, signFN)"
                                />
                                <mat-error *ngIf="signFN.errors?.['required']"
                                  >First Name is required</mat-error
                                >
                                <mat-error *ngIf="signFN.errors?.['invalid']"
                                  >First Name is invalid</mat-error
                                >
                                <mat-error *ngIf="signFN.errors?.['pattern']"
                                  >First Name is invalid</mat-error
                                >
                                <mat-error *ngIf="signFN.errors?.['nomatch']"
                                  >Only Alphabetical, Space, Hyphen, and
                                  Apostrophe are allowed</mat-error
                                >
                              </mat-form-field>
                            </div>
                            <div class="col">
                              <mat-form-field appearance="outline">
                                <mat-label
                                  >Last Name<ng-container
                                    *ngIf="!signLastNameRequired"
                                    >*</ng-container
                                  ></mat-label
                                >
                                <input
                                  matInput
                                  type="text"
                                  name="signLastName"
                                  [(ngModel)]="
                                    formNv.referralCase.submitterLastName
                                  "
                                  maxlength="20"
                                  #signLN="ngModel"
                                  [required]="signLastNameRequired"
                                  uppercase
                                  pattern="^[a-zA-Z](?!.*--)(?!.*-')(?!.* ')(?!.*'-)(?!.*' )(?!.* -)(?!.*- )(?!.*  )(?!.*'')[a-zA-Z \-']+$"
                                  (keypress)="allowAlphabets2($event, signLN)"
                                />
                                <mat-error *ngIf="signLN.errors?.['required']"
                                  >Last Name is required</mat-error
                                >
                                <mat-error *ngIf="signLN.errors?.['invalid']"
                                  >Last Name is invalid</mat-error
                                >
                                <mat-error *ngIf="signLN.errors?.['pattern']"
                                  >Last Name is invalid</mat-error
                                >
                                <mat-error *ngIf="signLN.errors?.['nomatch']"
                                  >Only Alphabetical, Space, Hyphen, and
                                  Apostrophe are allowed</mat-error
                                >
                              </mat-form-field>
                            </div>
                          </div>
                        </mat-card-content>
                      </mat-card>
                    </div>

                    <br />
                    <br />

                    <br />
                    <div class="container text-center">
                      <div class="row">
                        <div class="col text-danger text-center fw-semibold">
                          Enter the characters shown below into the box provided
                          before clicking Submit.
                        </div>
                      </div>
                      <br />
                      <div class="row text-center align-items-center">
                        <div class="col-4"></div>
                      
                        <div class="col-4 d-flex">
                          <div
                            class="p-3 text-white rounded fs-1 fw-bold fst-italic"
                            style="background-image: url('app/module/pierhippnv/assets/img/capcha7.jpg');
                                   background-size: cover; flex: 2.5; display: flex; align-items: center; justify-content: center;">
                            {{ captchaText }}
                          </div>
                          <div class="d-flex flex-column justify-content-start ms-4" style="flex: 1;">
                            <div class="d-flex flex-column" style="flex: 1;">
                              <div class="d-flex align-items-center mb-3" style="flex-grow: 0; flex-shrink: 1; flex-basis: 30px;">
                                <i
                                  class="material-icons"
                                  style="font-size: 2.6rem; color: #007bff; cursor: pointer;"
                                  (click)="playCaptchaAudio()"
                                  title="Play Audio"
                                >
                                  volume_up
                                </i>
                                <span class="ms-2" style="font-size: 1rem;">Play Audio</span>
                              </div>
                              <div class="d-flex align-items-center" style="flex-grow: 0; flex-shrink: 1; flex-basis: 30px;">
                                <i
                                  class="material-icons"
                                  style="font-size: 2.6rem; color: #28a745; cursor: pointer;"
                                  (click)="generateCaptcha()"
                                  title="Refresh Captcha"
                                >
                                  refresh
                                </i>
                                <span class="ms-2" style="font-size: 1rem;">Refresh Captcha</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      <div class="col-4"></div>
                      </div>                                                                                
                      <br/>
                      <div class="row">
                        <div class="col"></div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label
                              >Captcha<ng-container *ngIf="!captchaRequired"
                                >*</ng-container
                              ></mat-label
                            >
                            <input
                              matInput
                              type="text"
                              name="captcha"
                              [(ngModel)]="captchaEntered"
                              #captcha="ngModel"
                              [required]="captchaRequired"
                              (blur)="checkCaptch($event)"
                              minlength="6"
                              maxlength="6"
                            />
                            <mat-error *ngIf="captcha.errors?.['required']"
                              >Captcha code is required</mat-error
                            >
                            <mat-error *ngIf="captcha.errors?.['nomatch']"
                              >Captcha code does not match</mat-error
                            >
                          </mat-form-field>
                        </div>
                        <div class="col"></div>
                      </div>
                      <div class="row justify-content-md-center">
                        <div class="col">
                          <button
                            mat-raised-button
                            color="warn"
                            matStepperPrevious
                            class="m-2"
                            style="background-color: #b89d18; color: white"
                            (click)="goBack4()"
                          >
                            Previous
                          </button>

                          <button
                            mat-raised-button
                            color="primary"
                            id="formSubmit"
                            type="submit"
                            class="m-2"
                            [disabled]="
                              customerForm.pristine || !customerForm.valid
                            "
                            (click)="goForward5()"
                          >
                            {{ operationText }}
                          </button>
                          <button
                            mat-raised-button
                            id="formReset"
                            class="m-2"
                            type="button"
                            [disabled]="
                              customerForm.pristine || !customerForm.valid
                            "
                            (click)="cancel($event)"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />

                  <div class="alert alert-danger" *ngIf="errorMessage">
                    {{ errorMessage }}
                  </div>

                  <br />
                </fieldset>
              </mat-step>
              <br />
            </mat-horizontal-stepper>
          </div>
        </form>
      </div>
    </div>
    <div class="form-bg" *ngIf="isValidFormSubmitted">
      <ng-container *ngIf="submittedResponse.referralId != undefined">
        <div class="row">
          <div class="col text-center text-white fw-bold">
            Time left: <span class="count">{{ display }}</span>
          </div>
          <br />
        </div>
        <div
          class="container-fluid rounded p-3 bg-light"
          style="border: 2px solid #63b1bc"
        >
          <fieldset
            class="shadow p-5 mb-1 rounded-5"
            style="border: 2px solid #63b1bc"
          >
            <legend
              class="float-none w-auto p-1 mx-5 fw-bold fs-1"
              style="color: #0f6db7"
            >
              Your NVHIPP application has been submitted
            </legend>
  
            <div class="container">
              <p class="fw-bold text-center">
                Confirmation ID : {{ this.submittedResponse.referralId }}
              </p>
              <p>
                Your application has been submitted successfully.
                <a
                  [href]="downloadLink"
                  (click)="openPdf()"
                  title="Submitted Form"
                  role="presentation"
                  type="application/pdf"
                  aria-label="Submitted Form"
                  lang="en"
                  alt="Submitted Form"
                  >Download Form</a
                >
                to print the submitted application for your records. We will
                contact you to let you know if we need additional information to
                confirm your eligibility.
              </p>
            </div>
          </fieldset>
          <br />
          <br />
          <!-- <fieldset class="shadow p-5 mb-1 rounded-5" style="border: 2px solid #63b1bc">
            <legend class="float-none w-auto p-1 mx-5 fw-bold fs-1" style="color: #003057">
              Register for Premium Reimbursement
            </legend>
  
            <div class="container">
              <p class="fw-bold">
                If your application is approved, you will be eligible to receive premium
                reimbursement.
              </p>
              <p class="fw-bold">
                You must complete and submit the following documents to receive
                reimbursement:
              </p>
              <br />
              <br />
              <ul class="fw-bold">
                <li>
                  Download and complete the
                  <a [href]="w9_pdf" lang="en" download>W-9 Form</a>
                </li>
                <li>
                  Download and complete the
                  <a [href]="EFT_pdf" lang="en" download>Electronic Funds Transfer (EFT)
                    Form</a>
                </li>
              </ul>
              <br />
              <br />
              <div class="text-center text-secondary fw-bold">
                Send completed forms in one of the following ways:
  
              </div>
              <br />
              <div class="text-center  fw-bold">
                Email: <a target="_blank" [href]="emailTo" alt="email" >{{email}}</a> |
                Fax: {{faxNo}} | Mail to: {{address}}
              </div>
              <br />
              <br />
            </div> -->
          <!-- </fieldset> -->
        </div>
      </ng-container>
      <ng-container *ngIf="submittedResponse.referralId == undefined">
        <div class="container text-center text-danger-emphasis bg-danger-subtle rounded-3">
          <br/>
          <p class="fs-1"><i class="bi bi-exclamation-circle-fill "></i></p>
          <ng-container *ngIf="apiError && apiError.status == 500">
            <h1>Something Went Wrong</h1>
            <h4>Sorry! Your request could not be processed as something went wrong on our side.</h4>
            <h4>{{getMessageServerDown()}}</h4>
          </ng-container>
          <ng-container *ngIf="apiError && apiError.status != 500">
            <h1>Error occured from server side <strong> {{apiError.status}} {{apiError.statusText}}</strong>  </h1>
            <h4>Your request could not be processed due to below error</h4>
            <p>
              <ng-container *ngIf="apiError.error.detail.detail">{{apiError.error.detail}}</ng-container>
              <ng-container *ngIf="!apiError.error.detail.detail">{{apiError.message}}</ng-container>
              </p>
          </ng-container>
          <br/>
        </div>
      </ng-container>
      
    </div>
  </mat-card-content>
</mat-card>
